import * as React3 from 'react';
import React3__default, { forwardRef, useRef, useState, useCallback, useEffect, createContext, useId, useContext, useMemo, createElement } from 'react';
import styled6 from '@emotion/styled';
import { motion, AnimatePresence, LayoutGroup, LazyMotion, domAnimation } from 'framer-motion';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { createPortal } from 'react-dom';
import { css } from '@emotion/react';
import { useMergeRefs, noop, OutSideClick, useSelect, useOutsideClick, useParentElementClick, isNullOrUndefined } from '@shoplflow/utils';
import Scrollbars from 'react-custom-scrollbars-2';
import { FloatingPortal, autoUpdate, offset, autoPlacement } from '@floating-ui/react';
export { arrow, flip, hide, inline, offset, shift, size } from '@floating-ui/react';
import { useFloating } from '@floating-ui/react-dom';
import * as ShoplAssets from '@shoplflow/shopl-assets';
import { DownArrowSolidXsmallIcon, DownArrowIcon, FirstPageIcon, LeftArrowIcon, RightArrowIcon, EndPageIcon } from '@shoplflow/shopl-assets';
import * as HadaAssets from '@shoplflow/hada-assets';
import { flip, shift, offset as offset$1 } from '@floating-ui/core';
import DatePicker2 from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SimpleBarReact from 'simplebar-react';
import { ko } from 'date-fns/locale';
import { getISOWeek, getISOWeekYear, startOfMonth, endOfMonth, differenceInCalendarMonths, getISOWeeksInYear, differenceInCalendarISOWeeks, startOfISOWeek, addWeeks, endOfISOWeek } from 'date-fns';

var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/.pnpm/classnames@2.3.2/node_modules/classnames/index.js
var require_classnames = __commonJS({
  "../../node_modules/.pnpm/classnames@2.3.2/node_modules/classnames/index.js"(exports, module) {
    (function() {
      var hasOwn = {}.hasOwnProperty;
      function classNames2() {
        var classes = [];
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (!arg)
            continue;
          var argType = typeof arg;
          if (argType === "string" || argType === "number") {
            classes.push(arg);
          } else if (Array.isArray(arg)) {
            if (arg.length) {
              var inner = classNames2.apply(null, arg);
              if (inner) {
                classes.push(inner);
              }
            }
          } else if (argType === "object") {
            if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
              classes.push(arg.toString());
              continue;
            }
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          }
        }
        return classes.join(" ");
      }
      if (typeof module !== "undefined" && module.exports) {
        classNames2.default = classNames2;
        module.exports = classNames2;
      } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) {
        define("classnames", [], function() {
          return classNames2;
        });
      } else {
        window.classNames = classNames2;
      }
    })();
  }
});
var useDomain = (domain = "SHOPL") => {
  const [domainType, setDomainType] = useState(void 0);
  useEffect(() => {
    if (domain) {
      setDomainType(domain);
    }
  }, [domain]);
  useEffect(() => {
    if (!domainType) {
      return;
    }
    document.documentElement.dataset.shoplflow = domainType == null ? void 0 : domainType.toLowerCase();
  }, [domainType]);
  return [domainType];
};
var getDomain = () => {
  return document.documentElement.dataset.shoplflow;
};

// src/animation/fadeInOut.ts
var fadeInOut = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.1
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.1
    }
  }
};
var BackDropStyled = styled6(motion.div)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${({ zIndex }) => zIndex || 2e4};
  width: 100%;
  height: 100%;
  background: rgba(51, 51, 51, 0.6);
`;
var BackDrop = ({ children, zIndex }) => {
  return /* @__PURE__ */ jsx(
    BackDropStyled,
    {
      variants: fadeInOut,
      initial: "initial",
      animate: "animate",
      exit: "exit",
      "data-shoplflow": "BackDrop",
      zIndex,
      children
    }
  );
};
var BackDrop_default = BackDrop;
var getSizeBySizeVariant = (size2) => {
  switch (size2) {
    case "XS":
      return "18px";
    case "S":
      return "24px";
    case "M":
      return "32px";
    case "L":
      return "48px";
    case "XL":
      return "72px";
    default:
      return "32px";
  }
};
var StyledAvatar = styled6.picture`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ sizeVar }) => getSizeBySizeVariant(sizeVar)};
  height: ${({ sizeVar }) => getSizeBySizeVariant(sizeVar)};
  position: relative;
  overflow: hidden;
  border-radius: 50%;
`;
var StyledAvatarContainer = styled6.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: fit-content;
  position: relative;
`;
var StyledAvatarImage = styled6.img`
  width: 100%;
  height: 100%;
`;
var StyledAvatarBadge = styled6.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: fit-content;
  bottom: 0;
  right: 0;
`;

// src/assets/mocks/AvatarNone.png
var AvatarNone_default = "./AvatarNone-F5VQQNT7.png";
var Avatar = (_a) => {
  var _b = _a, { src, badge } = _b, rest = __objRest(_b, ["src", "badge"]);
  return /* @__PURE__ */ jsxs(StyledAvatarContainer, { children: [
    /* @__PURE__ */ jsx(StyledAvatar, __spreadProps(__spreadValues({ "data-shoplflow": "Avatar" }, rest), { children: /* @__PURE__ */ jsx(StyledAvatarImage, { src: src != null ? src : AvatarNone_default }) })),
    /* @__PURE__ */ jsx(StyledAvatarBadge, { children: badge })
  ] });
};
var Avatar_default = Avatar;

// src/components/Avatar/Avatar.types.ts
var AvatarSizeVariants = {
  XS: "XS",
  S: "S",
  M: "M",
  L: "L",
  XL: "XL"
};

// src/styles/tokens.ts
var fontWeightRegular = "var(--font-weight-regular)";
var fontWeightMedium = "var(--font-weight-medium)";
var fontWeightBold = "var(--font-weight-bold)";
var fontWeightTokens = {
  fontWeightRegular,
  fontWeightMedium,
  fontWeightBold
};
var borderRadius04 = "var(--border-radius04)";
var borderRadius06 = "var(--border-radius06)";
var borderRadius08 = "var(--border-radius08)";
var borderRadius12 = "var(--border-radius12)";
var borderRadius16 = "var(--border-radius16)";
var borderRadius20 = "var(--border-radius20)";
var borderRadiusTokens = {
  borderRadius04,
  borderRadius06,
  borderRadius08,
  borderRadius12,
  borderRadius16,
  borderRadius20
};
var coolgray300 = "var(--coolgray300)";
var coolgray200 = "var(--coolgray200)";
var coolgray100 = "var(--coolgray100)";
var coolgray50 = "var(--coolgray50)";
var navy400 = "var(--navy400)";
var navy300 = "var(--navy300)";
var neutral0 = "var(--neutral0)";
var neutral100 = "var(--neutral100)";
var neutral150 = "var(--neutral150)";
var neutral200 = "var(--neutral200)";
var neutral300 = "var(--neutral300)";
var neutral350 = "var(--neutral350)";
var neutral400 = "var(--neutral400)";
var neutral500 = "var(--neutral500)";
var neutral600 = "var(--neutral600)";
var neutral700 = "var(--neutral700)";
var neutral400_5 = "var(--neutral400_5)";
var red300 = "var(--red300)";
var red200 = "var(--red200)";
var red100 = "var(--red100)";
var ocean300 = "var(--ocean300)";
var ocean200 = "var(--ocean200)";
var ocean100 = "var(--ocean100)";
var purple400 = "var(--purple400)";
var purple300 = "var(--purple300)";
var purple100 = "var(--purple100)";
var yellow300 = "var(--yellow300)";
var yellow200 = "var(--yellow200)";
var yellow100 = "var(--yellow100)";
var green300 = "var(--green300)";
var green200 = "var(--green200)";
var green100 = "var(--green100)";
var shopl400 = "var(--shopl400)";
var shopl300 = "var(--shopl300)";
var shopl200 = "var(--shopl200)";
var shopl150 = "var(--shopl150)";
var shopl100 = "var(--shopl100)";
var hada400 = "var(--hada400)";
var hada300 = "var(--hada300)";
var hada200 = "var(--hada200)";
var hada150 = "var(--hada150)";
var hada100 = "var(--hada100)";
var background = "var(--background)";
var primary100 = "var(--primary100)";
var primary150 = "var(--primary150)";
var primary200 = "var(--primary200)";
var primary300 = "var(--primary300)";
var primary400 = "var(--primary400)";
var colorTokens = {
  coolgray300,
  coolgray200,
  coolgray100,
  coolgray50,
  navy400,
  navy300,
  neutral0,
  neutral100,
  neutral150,
  neutral200,
  neutral300,
  neutral350,
  neutral400,
  neutral500,
  neutral600,
  neutral700,
  neutral400_5,
  red300,
  red200,
  red100,
  ocean300,
  ocean200,
  ocean100,
  purple400,
  purple300,
  purple100,
  yellow300,
  yellow200,
  yellow100,
  green300,
  green200,
  green100,
  shopl400,
  shopl300,
  shopl200,
  shopl150,
  shopl100,
  hada400,
  hada300,
  hada200,
  hada150,
  hada100,
  background,
  primary100,
  primary150,
  primary200,
  primary300,
  primary400
};
var spacing02 = "var(--spacing02)";
var spacing04 = "var(--spacing04)";
var spacing06 = "var(--spacing06)";
var spacing08 = "var(--spacing08)";
var spacing12 = "var(--spacing12)";
var spacing16 = "var(--spacing16)";
var spacing20 = "var(--spacing20)";
var spacing24 = "var(--spacing24)";
var spacing30 = "var(--spacing30)";
var spacing32 = "var(--spacing32)";
var spacing40 = "var(--spacing40)";
var spacingTokens = {
  spacing02,
  spacing04,
  spacing06,
  spacing08,
  spacing12,
  spacing16,
  spacing20,
  spacing24,
  spacing30,
  spacing32,
  spacing40
};
var dropShadow = "var(--dropShadow)";
var boxShadowTokens = {
  dropShadow
};
var heading1_700 = ".heading1_700";
var heading1_400 = ".heading1_400";
var heading2_700 = ".heading2_700";
var heading2_400 = ".heading2_400";
var heading3_700 = ".heading3_700";
var heading3_400 = ".heading3_400";
var title1_700 = ".title1_700";
var title1_400 = ".title1_400";
var title2_700 = ".title2_700";
var title2_500 = ".title2_500";
var title2_400 = ".title2_400";
var body1_700 = ".body1_700";
var body1_500 = ".body1_500";
var body1_400 = ".body1_400";
var body2_700 = ".body2_700";
var body2_500 = ".body2_500";
var body2_400 = ".body2_400";
var body3_400 = ".body3_400";
var body3_500 = ".body3_500";
var caption_700 = ".caption_700";
var caption_400 = ".caption_400";
var paragraph1 = ".paragraph1";
var paragraph2 = ".paragraph2";
var typographyTokens = {
  heading1_700,
  heading1_400,
  heading2_700,
  heading2_400,
  heading3_700,
  heading3_400,
  title1_700,
  title1_400,
  title2_700,
  title2_500,
  title2_400,
  body1_700,
  body1_500,
  body1_400,
  body2_700,
  body2_500,
  body2_400,
  body3_400,
  body3_500,
  caption_700,
  caption_400,
  paragraph1,
  paragraph2
};

// src/components/Stack/Stack.styled.ts
var StyledStack = styled6.div`
  display: flex;
  width: ${({ width }) => width};
  max-width: ${({ maxWidth }) => maxWidth};
  min-width: ${({ minWidth }) => minWidth};
  height: ${({ height }) => height};
  max-height: ${({ maxHeight }) => maxHeight};
  min-height: ${({ minHeight }) => minHeight};
  flex-direction: ${({ direction }) => direction};
  align-items: ${({ align }) => align};
  justify-content: ${({ justify }) => justify};
  gap: ${({ spacing }) => spacing && spacingTokens[spacing]};
  flex-wrap: ${({ flexWrap }) => flexWrap};
  flex: ${({ flex }) => flex};
  background: ${({ background: background2 }) => background2 ? colorTokens[background2] : "transparent"};
  border-radius: ${({ radius }) => radius && borderRadiusTokens[radius]};
  animation: 0.2s all ease-in-out;
`;
var createStackComponent = (stackOption) => forwardRef(function Stack2(_h, ref) {
  var _i = _h, {
    as = "div",
    spacing = stackOption == null ? void 0 : stackOption.spacing,
    direction = ((_a) => (_a = stackOption == null ? void 0 : stackOption.direction) != null ? _a : "column")(),
    align = ((_b) => (_b = stackOption == null ? void 0 : stackOption.align) != null ? _b : "flex-start")(),
    justify = ((_c) => (_c = stackOption == null ? void 0 : stackOption.justify) != null ? _c : "flex-start")(),
    width = ((_d) => (_d = stackOption == null ? void 0 : stackOption.width) != null ? _d : "initial")(),
    height = ((_e) => (_e = stackOption == null ? void 0 : stackOption.height) != null ? _e : "initial")(),
    flexWrap = ((_f) => (_f = stackOption == null ? void 0 : stackOption.flexWrap) != null ? _f : "initial")(),
    flex = ((_g) => (_g = stackOption == null ? void 0 : stackOption.flex) != null ? _g : "initial")(),
    radius = stackOption == null ? void 0 : stackOption.radius,
    background: background2 = stackOption == null ? void 0 : stackOption.background
  } = _i, rest = __objRest(_i, [
    "as",
    "spacing",
    "direction",
    "align",
    "justify",
    "width",
    "height",
    "flexWrap",
    "flex",
    "radius",
    "background"
  ]);
  return /* @__PURE__ */ jsx(
    StyledStack,
    __spreadProps(__spreadValues({
      as,
      spacing,
      ref,
      direction,
      align,
      justify,
      width,
      height,
      flexWrap,
      flex,
      background: background2,
      radius
    }, rest), {
      "data-shoplflow": "Stack",
      children: rest.children
    })
  );
});
var Stack = createStackComponent();
Stack.Vertical = createStackComponent({ direction: "column" });
Stack.Horizontal = createStackComponent({ direction: "row" });
var MotionStack = motion(Stack);
MotionStack.Vertical = motion(Stack.Vertical);
MotionStack.Horizontal = motion(Stack.Horizontal);
var Stack_default = Stack;
var StyledStackContainer = styled6.div`
  display: flex;
  width: ${({ width }) => width};
  max-width: ${({ maxWidth }) => maxWidth};
  min-width: ${({ minWidth }) => minWidth};
  height: ${({ height }) => height};
  max-height: ${({ maxHeight }) => maxHeight};
  min-height: ${({ minHeight }) => minHeight};
  flex-direction: ${({ direction }) => direction};
  align-items: ${({ align }) => align};
  justify-content: ${({ justify }) => justify};
  gap: ${({ spacing }) => spacing && spacingTokens[spacing]};
  flex-wrap: ${({ flexWrap }) => flexWrap};
  flex: ${({ flex }) => flex};
  padding: ${({ padding }) => padding};
  margin: ${({ margin }) => margin};
  background: ${({ background: background2 }) => background2 ? colorTokens[background2] : "transparent"};
  border-radius: ${({ radius }) => radius && borderRadiusTokens[radius]};
  animation: 0.2s all ease-in-out;
`;
var createStackComponent2 = (stackOption) => forwardRef(function Stack2(_j, ref) {
  var _k = _j, {
    as = "div",
    spacing = stackOption == null ? void 0 : stackOption.spacing,
    direction = ((_a) => (_a = stackOption == null ? void 0 : stackOption.direction) != null ? _a : "column")(),
    align = ((_b) => (_b = stackOption == null ? void 0 : stackOption.align) != null ? _b : "flex-start")(),
    justify = ((_c) => (_c = stackOption == null ? void 0 : stackOption.justify) != null ? _c : "flex-start")(),
    width = ((_d) => (_d = stackOption == null ? void 0 : stackOption.width) != null ? _d : "initial")(),
    height = ((_e) => (_e = stackOption == null ? void 0 : stackOption.height) != null ? _e : "initial")(),
    flexWrap = ((_f) => (_f = stackOption == null ? void 0 : stackOption.flexWrap) != null ? _f : "initial")(),
    flex = ((_g) => (_g = stackOption == null ? void 0 : stackOption.flex) != null ? _g : "initial")(),
    radius = stackOption == null ? void 0 : stackOption.radius,
    margin = ((_h) => (_h = stackOption == null ? void 0 : stackOption.margin) != null ? _h : "initial")(),
    padding = ((_i) => (_i = stackOption == null ? void 0 : stackOption.padding) != null ? _i : "initial")(),
    background: background2 = stackOption == null ? void 0 : stackOption.background
  } = _k, rest = __objRest(_k, [
    "as",
    "spacing",
    "direction",
    "align",
    "justify",
    "width",
    "height",
    "flexWrap",
    "flex",
    "radius",
    "margin",
    "padding",
    "background"
  ]);
  return /* @__PURE__ */ jsx(
    StyledStackContainer,
    __spreadProps(__spreadValues({
      as,
      spacing,
      ref,
      direction,
      align,
      justify,
      width,
      height,
      flexWrap,
      flex,
      background: background2,
      radius,
      margin,
      padding
    }, rest), {
      "data-shoplflow": "StackContainer",
      children: rest.children
    })
  );
});
var StackContainer = createStackComponent2();
StackContainer.Vertical = createStackComponent2({ direction: "column" });
StackContainer.Horizontal = createStackComponent2({ direction: "row" });
var MotionStackContainer = motion(StackContainer);
MotionStackContainer.Vertical = motion(StackContainer.Vertical);
MotionStackContainer.Horizontal = motion(StackContainer.Horizontal);
var StackContainer_default = StackContainer;
var setEllipsis = (maxLines) => {
  return css`
    display: -webkit-box;
    line-clamp: ${maxLines};
    -webkit-line-clamp: ${maxLines};
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
  `;
};
var StyledText = styled6.span`
  display: ${({ display }) => display && display};
  align-items: center;
  color: ${({ color }) => color && colorTokens[color]};
  ${({ lineClamp }) => lineClamp && setEllipsis(lineClamp)};
  text-align: ${({ textAlign }) => textAlign && textAlign};
  white-space: ${({ whiteSpace }) => whiteSpace && whiteSpace};
  text-overflow: ${({ textOverflow }) => textOverflow && textOverflow};
  ${({ textDecorations }) => textDecorations && css`
      text-decoration: ${textDecorations};
    `};
  ${({ opacity }) => opacity && css`
      opacity: ${opacity};
    `};
  ${({ wordBreak }) => wordBreak && css`
      word-break: ${wordBreak};
    `};
`;
var Text = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      children,
      typography = "body1_400",
      whiteSpace,
      color = "neutral700",
      display = "inline-block",
      textAlign = "start",
      textOverflow,
      className,
      as
    } = _b, rest = __objRest(_b, [
      "children",
      "typography",
      "whiteSpace",
      "color",
      "display",
      "textAlign",
      "textOverflow",
      "className",
      "as"
    ]);
    return /* @__PURE__ */ jsx(
      StyledText,
      __spreadProps(__spreadValues({
        ref,
        whiteSpace,
        className: className ? `${typography} ${className}` : typography,
        color,
        display,
        textAlign,
        textOverflow,
        as
      }, rest), {
        "data-shoplflow": "Text",
        children
      })
    );
  }
);
var Text_default = Text;
var MODAL_SIZE_XXS = 400;
var MODAL_SIZE_XS = 500;
var MODAL_SIZE_S = 560;
var MODAL_SIZE_M = 640;
var MODAL_SIZE_L = 768;
var MODAL_SIZE_XL = 1040;
var MODAL_SIZE_XXL = 1280;
var MODAL_SIZE_XXXL = 1600;
var getModalWidthFromSize = (size2) => {
  switch (size2) {
    case "XXS":
      return MODAL_SIZE_XXS;
    case "XS":
      return MODAL_SIZE_XS;
    case "S":
      return MODAL_SIZE_S;
    case "M":
      return MODAL_SIZE_M;
    case "L":
      return MODAL_SIZE_L;
    case "XL":
      return MODAL_SIZE_XL;
    case "XXL":
      return MODAL_SIZE_XXL;
    case "XXXL":
      return MODAL_SIZE_XXXL;
    default:
      return MODAL_SIZE_M;
  }
};
var getModalBodyTopBottomPadding = (isIncludeHeader, sizeVar) => {
  if (sizeVar === "FULL") {
    return css`
      padding-top: 0;
      padding-bottom: 0;
    `;
  }
  if (isIncludeHeader) {
    return css`
      padding-top: 16px;
      padding-bottom: 24px;
    `;
  }
  return css`
    padding-top: 24px;
    padding-bottom: 24px;
  `;
};
var getFullScreenModal = () => {
  return css`
    min-height: 100vh;
    max-height: 100vh;
    width: 100vw;
    max-width: 100vw;
    border-radius: 0;
    box-shadow: none;
  `;
};
var checkMaxHeight = (height, viewport) => {
  const topBottomMargin = 64;
  if (height > 1200) {
    return 1200 - topBottomMargin;
  }
  if (height > viewport) {
    return viewport - topBottomMargin;
  }
  return height - topBottomMargin;
};
var Container = styled6.div`
  display: flex;
  flex-direction: column;
  border-radius: ${borderRadiusTokens.borderRadius08};
  background: ${colorTokens.neutral0};
  box-shadow: ${boxShadowTokens.dropShadow};
  overflow: hidden;
  flex-grow: 1;
  height: ${({ height, viewport }) => height ? `${checkMaxHeight(height, viewport)}px` : "initial"};
  min-height: 180px;
  max-height: 1200px;

  width: ${({ sizeVar }) => getModalWidthFromSize(sizeVar)}px;
  max-width: ${({ sizeVar }) => getModalWidthFromSize(sizeVar)}px;
  ${({ sizeVar }) => sizeVar && window.innerWidth <= getModalWidthFromSize(sizeVar) + 40 && css`
      width: ${window.innerWidth - 40}px;
      max-width: ${window.innerWidth - 40}px;
    `};
  ${({ sizeVar }) => sizeVar === "FULL" && getFullScreenModal()};
`;
var HeaderContainer = styled6.div`
  display: flex;
  width: 100%;
  min-height: 64px;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px 12px 24px;
  gap: 10px;
`;
var BodyContainer = styled6.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
  background: ${colorTokens.neutral0};
  box-sizing: border-box;
  min-height: ${({ minHeight }) => minHeight}px;
  max-height: ${({ maxHeight }) => maxHeight}px;
  flex: 1;
  ${({ isIncludeHeader, sizeVar }) => getModalBodyTopBottomPadding(isIncludeHeader, sizeVar)};
`;
var ModalBodyContainerInner = styled6.div`
  display: grid;
  align-self: stretch;
  flex-direction: column;
  flex-grow: 1;
  //스크롤 생성시 하단 padding 적용하기 위한 설정
  height: 100%;
  box-sizing: border-box;
`;
var ModalBodyContent = styled6.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  padding: 0 24px;
  ${({ sizeVar }) => sizeVar === "FULL" && css`
      padding: 0;
    `};
  background: ${colorTokens.neutral0};
`;
var FooterContainer = styled6.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 24px;
  gap: 12px;
  border-top: 1px solid ${colorTokens.neutral300};
  background: ${colorTokens.neutral0};
`;

// src/components/Modal/Modal.types.ts
var ModalSize = {
  XXS: "XXS",
  XS: "XS",
  S: "S",
  M: "M",
  L: "L",
  XL: "XL",
  XXL: "XXL",
  XXXL: "XXXL",
  FULL: "FULL"
};
var MODAL_HEADER_KEY = Symbol("MODAL_HEADER");
var MODAL_FOOTER_KEY = Symbol("MODAL_FOOTER");
var useViewportSizeObserver = () => {
  const [size2, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  useEffect(() => {
    const handleResize = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return size2;
};
var ModalContainer = (_a) => {
  var _b = _a, { children, height, outsideClick = noop } = _b, rest = __objRest(_b, ["children", "height", "outsideClick"]);
  const ref = useParentElementClick(outsideClick);
  const { height: windowHeight } = useViewportSizeObserver();
  const topBottomMargin = 64;
  const heightWidthMargin = height ? height + topBottomMargin : void 0;
  const childrenArray = React3__default.Children.toArray(children);
  const findHeader = childrenArray.find((child) => {
    if (!React3__default.isValidElement(child)) {
      return child;
    }
    if (child.type[MODAL_HEADER_KEY]) {
      return child;
    }
  });
  const findFooter = childrenArray.find((child) => {
    if (!React3__default.isValidElement(child)) {
      return child;
    }
    if (child.type[MODAL_FOOTER_KEY]) {
      return child;
    }
  });
  const addPropInChildren = React3__default.Children.map(childrenArray, (child) => {
    if (!React3__default.isValidElement(child)) {
      return child;
    }
    return React3__default.cloneElement(child, {
      isIncludeHeader: Boolean(findHeader),
      isIncludeFooter: Boolean(findFooter),
      sizeVar: rest.sizeVar,
      height: heightWidthMargin
    });
  });
  return /* @__PURE__ */ jsx(Container, __spreadProps(__spreadValues({ ref }, rest), { height: heightWidthMargin, viewport: windowHeight, "data-shoplflow": "Modal", children: addPropInChildren }));
};
var ModalContainer_default = ModalContainer;
var ModalFooter = ({ children }) => {
  return /* @__PURE__ */ jsx(FooterContainer, { children });
};
ModalFooter[MODAL_FOOTER_KEY] = true;
var ModalFooter_default = ModalFooter;
var ScrollArea = forwardRef((_a, ref) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  const scrollRef = useRef(null);
  const mergeRef = useMergeRefs(scrollRef, ref);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const onResize = useCallback(() => {
    setWindowWidth(window.innerWidth);
    setWindowHeight(window.innerHeight);
  }, []);
  useEffect(() => {
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [onResize]);
  return /* @__PURE__ */ jsx(Fragment, { children: Boolean(windowWidth) && Boolean(windowHeight) && /* @__PURE__ */ jsx(
    Scrollbars,
    __spreadProps(__spreadValues({
      ref: mergeRef,
      autoHide: true,
      autoHideTimeout: 1e3,
      autoHideDuration: 200
    }, rest), {
      "data-shoplflow": "ScrollArea",
      children
    })
  ) });
});
var ScrollArea_default = ScrollArea;
var ModalBody = ({
  children,
  isIncludeHeader = false,
  isIncludeFooter = false,
  sizeVar,
  height: modalContainerHeight
}) => {
  const { height: windowHeight } = useViewportSizeObserver();
  const headerHeight = 64;
  const footerHeight = 72;
  const topBottomMargin = 64;
  const getHeaderFooterHeight = useCallback(() => {
    let result = 0;
    if (isIncludeHeader) {
      result += headerHeight;
    }
    if (isIncludeFooter) {
      result += footerHeight;
    }
    return result;
  }, [isIncludeFooter, isIncludeHeader]);
  const headerFooterHeight = useMemo(() => getHeaderFooterHeight(), [getHeaderFooterHeight]);
  const setAutoHeightMin = () => {
    if (sizeVar === "FULL") {
      return windowHeight - headerFooterHeight;
    }
    if (modalContainerHeight) {
      if (modalContainerHeight <= 1200) {
        if (windowHeight < modalContainerHeight) {
          return windowHeight - topBottomMargin - headerFooterHeight;
        }
        return modalContainerHeight - topBottomMargin - headerFooterHeight;
      }
      return modalContainerHeight - topBottomMargin - headerFooterHeight;
    } else {
      return "100%";
    }
  };
  const setAutoHeightMax = () => {
    if (sizeVar === "FULL") {
      return windowHeight;
    }
    if (modalContainerHeight) {
      if (modalContainerHeight > 1200) {
        return 1200 - topBottomMargin - headerFooterHeight;
      }
      if (modalContainerHeight <= 1200) {
        if (windowHeight < modalContainerHeight) {
          return windowHeight - topBottomMargin - headerFooterHeight;
        }
        return modalContainerHeight - topBottomMargin - headerFooterHeight;
      }
    }
    if (!modalContainerHeight) {
      const heightUnderMaxHeight = windowHeight - topBottomMargin - headerFooterHeight;
      const heightOverMaxHeight = 1200 - topBottomMargin - headerFooterHeight;
      return windowHeight > 1200 ? heightOverMaxHeight : heightUnderMaxHeight;
    }
    return 0;
  };
  const setContentHeightMax = () => {
    let autoHeightMax = setAutoHeightMax();
    autoHeightMax = autoHeightMax - 24;
    if (isIncludeHeader) {
      autoHeightMax = autoHeightMax - 24;
    }
    if (!isIncludeHeader) {
      autoHeightMax = autoHeightMax - 16;
    }
    return autoHeightMax;
  };
  return /* @__PURE__ */ jsx(
    BodyContainer,
    {
      isIncludeHeader,
      sizeVar,
      minHeight: setAutoHeightMin(),
      maxHeight: setAutoHeightMax(),
      children: /* @__PURE__ */ jsx(
        ScrollArea_default,
        {
          id: `scrollbar`,
          universal: true,
          autoHeight: !modalContainerHeight,
          autoHeightMin: setAutoHeightMin(),
          autoHeightMax: setContentHeightMax(),
          style: {},
          children: /* @__PURE__ */ jsx(ModalBodyContainerInner, { children: /* @__PURE__ */ jsx(ModalBodyContent, { isIncludeHeader, sizeVar, children }) })
        }
      )
    }
  );
};
var ModalBody_default = ModalBody;
var ModalHeader = ({ children }) => {
  return /* @__PURE__ */ jsx(HeaderContainer, { children });
};
ModalHeader[MODAL_HEADER_KEY] = true;
var ModalHeader_default = ModalHeader;
var ModalHandlerContext = createContext({
  addModal: noop,
  removeModal: noop
});
var ModalContext = createContext([]);

// src/components/Modal/hooks/useModalValue.ts
var useModalValue = () => {
  const modal = useContext(ModalContext);
  return {
    modal
  };
};
var useHandleModal = () => {
  const { addModal, removeModal } = useContext(ModalHandlerContext);
  return {
    addModal,
    removeModal
  };
};
var ModalProvider = ({ children }) => {
  const [openedModals, setOpenedModals] = useState([]);
  const addModal = (component, id, zIndex) => {
    setOpenedModals((modals) => {
      if (modals) {
        return [...modals, { component, id, zIndex }];
      }
      return [{ component, id, zIndex }];
    });
  };
  const removeModal = (props) => {
    const { id, deps } = props || {
      id: void 0,
      deps: void 0
    };
    const isIncludeAllProps = Boolean(id && deps);
    const isIncludeId = Boolean(id);
    const isNotIncludeAllProps = !id && Boolean(isNullOrUndefined(deps));
    const isIncludeDeps = Boolean(Boolean(!isNullOrUndefined(deps)) && !id);
    if (isIncludeAllProps) {
      throw new Error("id\uC640 deps\uB294 \uB3D9\uC2DC\uC5D0 \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.");
    }
    if (isIncludeId) {
      setOpenedModals((modal) => {
        const filterModal = modal.filter((modal2) => modal2.id !== id);
        return [...filterModal];
      });
      return;
    }
    if (isNotIncludeAllProps || deps === 1) {
      setOpenedModals((modal) => {
        const removeModal2 = modal.slice(0, -1);
        return [...removeModal2];
      });
      return;
    }
    if (isIncludeDeps) {
      if (deps === 0 || deps === void 0) {
        return;
      }
      setOpenedModals((modal) => {
        const removeDeps = modal.slice(0, -deps);
        return [...removeDeps];
      });
      return;
    }
  };
  const dispatch = useMemo(() => ({ addModal, removeModal }), []);
  useEffect(() => {
    if (openedModals.length !== 1) {
      return;
    }
    document.body.style.cssText = "overflow:hidden";
    return () => {
      document.body.style.cssText = "overflow:unset";
    };
  }, [openedModals.length]);
  useEffect(() => {
    const closeAllModals = () => {
      setOpenedModals([]);
    };
    window.addEventListener("popstate", closeAllModals);
    return () => {
      window.removeEventListener("popstate", closeAllModals);
    };
  }, []);
  return /* @__PURE__ */ jsx(ModalContext.Provider, { value: openedModals, children: /* @__PURE__ */ jsx(ModalHandlerContext.Provider, { value: dispatch, children }) });
};
var ModalProvider_default = ModalProvider;

// src/components/Modal/index.ts
var Modal = {
  Container: ModalContainer_default,
  Header: ModalHeader_default,
  Body: ModalBody_default,
  Footer: ModalFooter_default
};
var SwitchContainer = styled6.div`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ isDisabled }) => isDisabled && 0.3};

  &:hover {
    background: ${({ isDisabled }) => !isDisabled && colorTokens.neutral400_5};
  }
`;
var StyledSwitch = styled6.input`
  appearance: none;
  border: none;
  border-radius: 12px;
  width: 28px;
  height: 18px;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  background: ${colorTokens.neutral350};
  padding: 2px;
  margin: 0;

  // slider
  &:before {
    content: '';
    left: 2px;
    display: block;
    position: absolute;
    width: 14px;
    height: 14px;
    background: ${colorTokens.neutral0};
    border-radius: 50%;
    transition: left 0.2s ease-in-out;
  }

  // selected
  &:checked {
    background: ${({ activeColor }) => colorTokens[activeColor]};
    &:before {
      left: 12px;
    }
  }

  // disabled
  &:disabled {
    cursor: auto;
  }
`;
var useOnToggle = (selected, defaultSelected) => {
  const [isToggle, setIsToggle] = useState(false);
  const isControlled = selected !== void 0;
  const handleToggle = () => {
    !isControlled && setIsToggle((prev) => !prev);
  };
  useEffect(() => {
    if (isControlled) {
      setIsToggle(selected);
    }
  }, [isControlled, selected]);
  useEffect(() => {
    if (!isControlled && defaultSelected !== void 0) {
      setIsToggle(defaultSelected);
    }
  }, [defaultSelected, isControlled]);
  return [isToggle, handleToggle];
};
var Switch = (_a) => {
  var _b = _a, {
    onChange,
    isSelected,
    disabled = false,
    activeColor = "primary300",
    defaultSelected = false
  } = _b, rest = __objRest(_b, [
    "onChange",
    "isSelected",
    "disabled",
    "activeColor",
    "defaultSelected"
  ]);
  const [isToggled, handleToggle] = useOnToggle(isSelected, defaultSelected);
  const handleOnChange = (e) => {
    handleToggle();
    onChange && onChange(e);
  };
  return /* @__PURE__ */ jsx(SwitchContainer, { isDisabled: disabled, children: /* @__PURE__ */ jsx(
    StyledSwitch,
    __spreadProps(__spreadValues({
      type: "checkbox",
      checked: isToggled,
      disabled,
      onChange: handleOnChange,
      activeColor
    }, rest), {
      "data-shoplflow": "Switch"
    })
  ) });
};
var Switch_default = Switch;

// src/components/Chips/ChipToggle/ChipToggle.types.ts
var ChipToggleStyleVariants = {
  SOLID: "SOLID"
};
var ChipToggleSizeVariants = {
  S: "S",
  XS: "XS"
};
var getDisabledStyle = (disabled) => {
  if (!disabled) {
    return;
  }
  return css`
    opacity: 50%;
    cursor: not-allowed !important;
  `;
};

// src/components/Chips/ChipToggle/ChipToggle.styled.ts
var getLineTypographyBySizeVar = (sizeVar) => {
  switch (sizeVar) {
    case "XS":
      return "body3_400";
    case "S":
      return "body2_400";
    default:
      return "body2_400";
  }
};
var solidStyle = ({
  isSelected,
  color,
  $radius
}) => css`
  padding: 7px 12px;
  gap: 4px;
  background: ${colorTokens.neutral150};
  border-radius: ${borderRadiusTokens.borderRadius06};
  & > span {
    color: ${colorTokens.neutral400};
  }
  &:hover {
    background: ${colorTokens.neutral200};
  }

  ${$radius && css`
    border-radius: ${borderRadiusTokens.borderRadius16};
  `};
  ${isSelected && css`
    background: ${colorTokens[color]};
    & > span {
      color: ${colorTokens["neutral0"]};
    }
    &:hover {
      background: ${colorTokens[color]};
    }
  `};
`;
var StyledChip = styled6.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  height: fit-content;
  width: fit-content;
  user-select: none;
  cursor: pointer;
  ${(props) => props.styleVar === "SOLID" && solidStyle(props)};
  ${({ disabled }) => getDisabledStyle(disabled)};
`;
var ChipToggle = (_a) => {
  var _b = _a, {
    text,
    isSelected,
    defaultSelected,
    color = "neutral600",
    radius,
    styleVar = ChipToggleStyleVariants.SOLID,
    sizeVar,
    leftSource,
    rightSource,
    onClick = noop,
    disabled = false
  } = _b, rest = __objRest(_b, [
    "text",
    "isSelected",
    "defaultSelected",
    "color",
    "radius",
    "styleVar",
    "sizeVar",
    "leftSource",
    "rightSource",
    "onClick",
    "disabled"
  ]);
  const [isToggled, handleToggle] = useOnToggle(isSelected, defaultSelected);
  const handleClick = (e) => {
    !disabled && handleToggle();
    !disabled && onClick && onClick(e);
  };
  return /* @__PURE__ */ jsxs(
    StyledChip,
    __spreadProps(__spreadValues({}, rest), {
      color,
      $radius: radius,
      isSelected: isToggled,
      styleVar,
      sizeVar,
      onClick: handleClick,
      disabled,
      "data-shoplflow": "ChipToggle",
      children: [
        leftSource,
        /* @__PURE__ */ jsx(Text_default, { typography: getLineTypographyBySizeVar(sizeVar), children: text }),
        rightSource
      ]
    })
  );
};
var ChipToggle_default = ChipToggle;

// src/utils/getNextColor.ts
var getNextColor = (color, step = 1) => {
  const colorName = color.replace(/[0-9]|_/g, "");
  const colorTokenKeys = Object.keys(colorTokens);
  const findColorToken = colorTokenKeys.filter((colorToken) => colorToken.includes(colorName));
  const extractNumbers = (str) => {
    const formattedStr = str.replace(/_/g, ".");
    const regex = /\d+(\.\d+)?/g;
    const match = formattedStr.match(regex);
    return match ? parseFloat(match[0]) : 0;
  };
  const sortColorToken = findColorToken.sort((a, b) => extractNumbers(a) - extractNumbers(b));
  const currentIndex = sortColorToken.indexOf(color);
  let newIndex = currentIndex;
  let stepCount = 0;
  while (stepCount < Math.abs(step)) {
    newIndex += Math.sign(step);
    if (newIndex < 0 || newIndex >= sortColorToken.length) {
      break;
    }
    if (!sortColorToken[newIndex].endsWith("_5") && !sortColorToken[newIndex].endsWith("50")) {
      stepCount++;
    }
  }
  newIndex = Math.max(0, Math.min(newIndex, sortColorToken.length - 1));
  return sortColorToken[newIndex];
};

// src/components/Chips/ChipButton/ChipButton.styled.ts
var getLineTypographyBySizeVar2 = (sizeVar) => {
  switch (sizeVar) {
    case "XS":
      return "caption_400";
    case "S":
      return "body3_400";
    default:
      return "body3_400";
  }
};
var lineStyle = ({ color }) => css`
  background: ${colorTokens.neutral0};
  border: 1px solid ${colorTokens[color]};
  border-radius: ${borderRadiusTokens.borderRadius20};
  &:hover {
    border: 1px solid ${colorTokens[getNextColor(color, 2)]};
  }
  & > span {
    color: ${colorTokens[getNextColor(color, 4)]};
  }
`;
var getStyleBySizeVar = (sizeVar) => {
  switch (sizeVar) {
    case "XS":
      return css`
        padding: 4px 8px;
      `;
    case "S":
      return css`
        padding: 7px 12px;
      `;
    default:
      return css`
        padding: 7px 12px;
      `;
  }
};
var StyledChipButton = styled6.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  height: fit-content;
  width: fit-content;
  gap: 4px;
  cursor: pointer;
  ${({ sizeVar }) => getStyleBySizeVar(sizeVar)};
  ${(props) => props.styleVar === "LINE" && lineStyle(props)};
  ${({ disabled }) => getDisabledStyle(disabled)};
  background: ${({ background: background2 }) => background2 && colorTokens[background2]};
`;

// src/components/Chips/ChipButton/ChipButton.types.ts
var ChipButtonStyleVariants = {
  LINE: "LINE"
};
var ChipButtonSizeVariants = {
  S: "S",
  XS: "XS"
};
var ChipButton = (_a) => {
  var _b = _a, {
    styleVar = ChipButtonStyleVariants.LINE,
    color = "neutral200",
    sizeVar = ChipButtonSizeVariants.S,
    text,
    onClick = noop,
    disabled = false
  } = _b, rest = __objRest(_b, [
    "styleVar",
    "color",
    "sizeVar",
    "text",
    "onClick",
    "disabled"
  ]);
  const handleOnClick = (e) => {
    !disabled && onClick(e);
  };
  return /* @__PURE__ */ jsx(
    StyledChipButton,
    __spreadProps(__spreadValues({
      styleVar,
      color
    }, rest), {
      onClick: handleOnClick,
      disabled,
      "data-shoplflow": "ChipButton",
      children: /* @__PURE__ */ jsx(Text_default, { typography: getLineTypographyBySizeVar2(sizeVar), children: text })
    })
  );
};
var ChipButton_default = ChipButton;
var getStyleByStyleVar = (styleVar, color, disabled) => {
  switch (styleVar) {
    case "PRIMARY":
      return css`
        border: 1px solid ${colorTokens.primary400};
        background-color: ${colorTokens.primary300};
        :hover {
          background-color: ${!disabled && colorTokens.primary400};
        }
      `;
    case "SECONDARY":
      return css`
        border: 1px solid ${colorTokens.neutral350};
        background-color: ${colorTokens.neutral0};
        :hover {
          background-color: ${!disabled && colorTokens.neutral100};
        }
      `;
    case "SOLID":
      if (!color) {
        throw new Error("Button\uC758 SOLID \uC18D\uC131\uC740 color\uB97C \uD544\uC218\uB85C \uBC1B\uC2B5\uB2C8\uB2E4.");
      }
      return css`
        border: 1px solid ${colorTokens[getNextColor(color)]};
        background-color: ${colorTokens[color]};
        :hover {
          background-color: ${colorTokens[getNextColor(color)]};
        }
      `;
    case "GHOST":
      return css`
        border: 1px solid transparent;
        background-color: transparent;
        :hover {
          background-color: ${!disabled && colorTokens.neutral400_5};
        }
      `;
    default:
      return css`
        border: 1px solid ${colorTokens.primary400};
        background-color: ${colorTokens.primary300};
      `;
  }
};
var getStyleBySizeVar2 = (sizeVar) => {
  switch (sizeVar) {
    case "M":
      return css`
        min-width: 72px;
        min-height: 40px;
      `;
    case "S":
      return css`
        min-width: 54px;
        min-height: 32px;
      `;
    default:
      return css`
        min-width: 72px;
        min-height: 40px;
      `;
  }
};
var StyledButton = styled6.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: fit-content;
  width: fit-content;
  gap: 4px;
  padding: 0 12px;
  border-radius: 6px;
  cursor: pointer;
  ${({ styleVar, color, disabled }) => getStyleByStyleVar(styleVar, color, disabled)};
  ${({ sizeVar }) => getStyleBySizeVar2(sizeVar)};
  ${({ disabled }) => getDisabledStyle(disabled)};
`;
var LoadingSpinner = ({ color = "neutral0" }) => {
  return /* @__PURE__ */ jsxs("svg", { width: "24", height: "24", stroke: colorTokens[color], viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx("style", { children: `
          .spinner { transform-origin: center; animation: spinner_rotation 2s linear infinite; }
          .spinner circle { stroke-linecap: round; animation: spinner_dash 1.5s ease-in-out infinite; }
          @keyframes spinner_rotation { 100% { transform: rotate(360deg); } }
          @keyframes spinner_dash { 
            0% { stroke-dasharray: 0 150; stroke-dashoffset: 0; }
            47.5% { stroke-dasharray: 42 150; stroke-dashoffset: -16; }
            95%, 100% { stroke-dasharray: 42 150; stroke-dashoffset: -59; }
          }
        ` }),
    /* @__PURE__ */ jsx("g", { className: "spinner", children: /* @__PURE__ */ jsx("circle", { cx: "12", cy: "12", r: "9.5", fill: "none", strokeWidth: "2" }) })
  ] });
};
var LoadingSpinner_default = LoadingSpinner;
var Button = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      styleVar = "PRIMARY",
      sizeVar = "M",
      style,
      color,
      as,
      children,
      leftSource,
      rightSource,
      isLoading = false,
      lineClamp
    } = _b, rest = __objRest(_b, [
      "styleVar",
      "sizeVar",
      "style",
      "color",
      "as",
      "children",
      "leftSource",
      "rightSource",
      "isLoading",
      "lineClamp"
    ]);
    return /* @__PURE__ */ jsxs(
      StyledButton,
      __spreadProps(__spreadValues({
        styleVar,
        sizeVar,
        className: styleVar,
        style,
        as,
        ref,
        color
      }, rest), {
        "data-shoplflow": "Button",
        children: [
          leftSource,
          isLoading ? /* @__PURE__ */ jsx(LoadingSpinner_default, { color: styleVar === "SECONDARY" || styleVar === "GHOST" ? "neutral500" : "neutral0" }) : /* @__PURE__ */ jsx(
            Text_default,
            {
              lineClamp,
              whiteSpace: "nowrap",
              wordBreak: "keep-all",
              color: styleVar === "PRIMARY" ? "neutral0" : "neutral700",
              typography: sizeVar === "M" ? "body1_400" : "body2_400",
              children
            }
          ),
          rightSource
        ]
      })
    );
  }
);
var Button_default = Button;

// src/components/Buttons/Button/Button.types.ts
var ButtonSizeVariants = {
  S: "S",
  M: "M"
};
var ButtonStyleVariants = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  SOLID: "SOLID",
  GHOST: "GHOST"
};
var getWidthAndHeightFromSizeVar = (sizeVar) => {
  switch (sizeVar) {
    case "M":
      return css`
        width: 40px;
        min-width: 40px;
        height: 40px;
        min-height: 40px;
      `;
    case "S":
      return css`
        width: 32px;
        min-width: 32px;
        height: 32px;
        min-height: 32px;
      `;
    case "XS":
      return css`
        width: 24px;
        min-width: 24px;
        height: 24px;
        min-height: 24px;
      `;
    default:
      return css`
        width: 40px;
        min-width: 40px;
        height: 40px;
        min-height: 40px;
      `;
  }
};
var getStyleByStyleVar2 = (styleVar, color, isHovered) => {
  switch (styleVar) {
    case "PRIMARY":
      return css`
        background: ${colorTokens.primary300};
        border: 1px solid ${colorTokens.primary400};
        ${isHovered && css`
          background: ${colorTokens.primary400};
        `}
      `;
    case "SECONDARY":
      return css`
        background: ${colorTokens.neutral0};
        border: 1px solid ${colorTokens.neutral350};
        ${isHovered && css`
          background: ${colorTokens.neutral100};
        `}
      `;
    case "SOLID":
      if (!color) {
        throw new Error("IconButton\uC758 SOLID \uC18D\uC131\uC740 color\uB97C \uD544\uC218\uB85C \uBC1B\uC2B5\uB2C8\uB2E4.");
      }
      return css`
        border: 1px solid ${colorTokens[getNextColor(color)]};
        background: ${colorTokens[color]};

        ${isHovered && css`
          background: ${colorTokens[getNextColor(color)]};
        `}
      `;
    case "GHOST":
      return css`
        border: 1px solid transparent;
        background: transparent;
        ${isHovered && css`
          background: ${colorTokens.neutral400_5};
        `}
      `;
    default:
      return css`
        border: 1px solid ${colorTokens.neutral200};
        ${isHovered && css`
          background: ${colorTokens.neutral100};
        `}
      `;
  }
};
var StyledIconButton = styled6.button`
  display: flex;
  flex-shrink: 0;
  border-radius: ${borderRadiusTokens.borderRadius06};
  justify-content: center;
  align-items: center;
  background: ${colorTokens.neutral0};
  cursor: pointer;
  ${({ styleVar, color, isHovered }) => getStyleByStyleVar2(styleVar, color, isHovered)};
  ${({ sizeVar }) => getWidthAndHeightFromSizeVar(sizeVar)};
  ${({ disabled }) => getDisabledStyle(disabled)};
  & > svg {
    width: 20px;
    height: 20px;
  }
`;
var IconButton = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      styleVar,
      sizeVar,
      disabled,
      children,
      color,
      onMouseEnter,
      onMouseLeave,
      isLoading = false,
      type = "button"
    } = _b, rest = __objRest(_b, [
      "styleVar",
      "sizeVar",
      "disabled",
      "children",
      "color",
      "onMouseEnter",
      "onMouseLeave",
      "isLoading",
      "type"
    ]);
    const [isHovered, setIsHovered] = useState(false);
    const handleOnMouseEnter = (e) => {
      setIsHovered(true);
      onMouseEnter && onMouseEnter(e);
    };
    const handleOnMouseLeave = (e) => {
      setIsHovered(false);
      onMouseLeave && onMouseLeave(e);
    };
    return /* @__PURE__ */ jsx(
      StyledIconButton,
      __spreadProps(__spreadValues({
        styleVar,
        sizeVar,
        disabled,
        color,
        ref,
        onMouseEnter: handleOnMouseEnter,
        onMouseLeave: handleOnMouseLeave,
        isHovered,
        type
      }, rest), {
        "data-shoplflow": "IconButton",
        children: isLoading ? /* @__PURE__ */ jsx(LoadingSpinner_default, { color: styleVar === "SECONDARY" || styleVar === "GHOST" ? "neutral500" : "neutral0" }) : children
      })
    );
  }
);
var IconButton_default = IconButton;

// src/components/Buttons/IconButton/IconButton.types.ts
var IconButtonSizeVariants = {
  XS: "XS",
  S: "S",
  M: "M"
};
var IconButtonStyleVariants = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  SOLID: "SOLID",
  GHOST: "GHOST"
};
var informationStyle = css`
  background: ${colorTokens.neutral100};
  & > span {
    color: ${colorTokens.neutral600};
  }
  & > svg > path {
    fill: ${colorTokens.neutral600};
  }
`;
var alertStyle = css`
  background: ${colorTokens.red100};
  & > span {
    align-self: center;
    color: ${colorTokens.red300};
  }
  & > svg > path {
    fill: ${colorTokens.red300};
  }
`;
var StyledCallout = styled6.div`
  display: flex;
  justify-content: flex-start;
  align-items: start;
  padding: 6px 8px;
  gap: 4px;
  border-radius: ${borderRadiusTokens.borderRadius08};
  ${({ styleVar }) => styleVar === "INFORMATION" && informationStyle}
  ${({ styleVar }) => styleVar === "ALERT" && alertStyle}
`;
var StyledCalloutIcon = styled6.svg`
  display: flex;
  height: 20px;
  min-height: 20px;
  width: 20px;
  min-width: 20px;
`;
styled6.div`
  padding: 2px 0;
`;
var Callout = (_a) => {
  var _b = _a, { children, styleVar = "INFORMATION" } = _b, rest = __objRest(_b, ["children", "styleVar"]);
  return /* @__PURE__ */ jsx(StyledCallout, __spreadProps(__spreadValues({}, rest), { styleVar, "data-shoplflow": "Callout", children }));
};
var CalloutText = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx(Text_default, __spreadProps(__spreadValues({}, rest), { typography: "paragraph2", children }));
};
var CalloutIcon = ({ iconSource }) => {
  return /* @__PURE__ */ jsx(StyledCalloutIcon, { as: iconSource });
};
Callout.Text = CalloutText;
Callout.Icon = CalloutIcon;
var Callout_default = Callout;

// src/components/Callout/Callout.types.ts
var CalloutTypes = {
  INFORMATION: "INFORMATION",
  ALERT: "ALERT"
};
var StyledPopper = styled6.div`
  width: ${({ width }) => width != null ? width : "fit-content"};
  height: ${({ height }) => height && height};
`;
var PopperContext = createContext(null);
var usePopper = () => {
  const context = React3.useContext(PopperContext);
  if (context === null) {
    throw new Error("usePopper must be used within a PopperProvider");
  }
  return context;
};
function assignRef(ref, value) {
  if (ref == null) {
    return;
  }
  if (typeof ref === "function") {
    ref(value);
    return;
  }
  try {
    ref.current = value;
  } catch (error) {
    throw new Error(`Cannot assign value '${String(value)}' to ref '${String(ref)}'`);
  }
}
function mergeRefs(...refs) {
  return (node) => {
    refs.forEach((ref) => {
      assignRef(ref, node);
    });
  };
}
function useMergeRefs2(...refs) {
  return useMemo(() => mergeRefs(...refs), refs);
}
var Popper = ({
  placement,
  offset: initialOffset = 0,
  autoPlacement: initialAutoPlacement,
  strategy = "absolute",
  middlewares,
  children
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const _a = useFloating({
    strategy,
    placement,
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(initialOffset),
      initialAutoPlacement && autoPlacement(__spreadValues({
        crossAxis: false
      }, initialAutoPlacement)),
      ...middlewares != null ? middlewares : []
    ]
  }), { refs, floatingStyles } = _a, floating = __objRest(_a, ["refs", "floatingStyles"]);
  return /* @__PURE__ */ jsx(
    PopperContext.Provider,
    {
      value: __spreadProps(__spreadValues(__spreadValues({ isOpen, setIsOpen }, floating), refs), { floatingStyles: __spreadProps(__spreadValues({}, floatingStyles), { zIndex: 20002 }) }),
      children
    }
  );
};
var PopperTrigger = forwardRef(
  (_a, ref) => {
    var _b = _a, { children, isOpen = false } = _b, rest = __objRest(_b, ["children", "isOpen"]);
    const { setReference, setIsOpen } = usePopper();
    const refs = useMergeRefs2(ref, setReference);
    useEffect(() => {
      setIsOpen(isOpen);
    }, [isOpen, setIsOpen]);
    return /* @__PURE__ */ jsx(StyledPopper, __spreadProps(__spreadValues({ ref: refs, "data-shoplflow": "Popper" }, rest), { children }));
  }
);
var PopperPortal = forwardRef(
  ({ children, animation: initialAnimation }, ref) => {
    const { floatingStyles, setFloating, isOpen } = usePopper();
    const animation = initialAnimation != null ? initialAnimation : fadeInOut;
    const refs = useMergeRefs2(ref, setFloating);
    if (!isOpen) {
      return null;
    }
    return /* @__PURE__ */ jsx(FloatingPortal, { children: /* @__PURE__ */ jsx(AnimatePresence, { children: /* @__PURE__ */ jsx(
      motion.div,
      {
        initial: animation.initial,
        animate: animation.animate,
        exit: animation.exit,
        ref: refs,
        style: floatingStyles,
        children
      }
    ) }) });
  }
);
Popper.Trigger = PopperTrigger;
Popper.Portal = PopperPortal;
var Popper_default = Popper;
var getDropdownHeightBySizeVar = (size2) => {
  switch (size2) {
    case "M":
      return "40px";
    case "S":
      return "32px";
    default:
      return "40px";
  }
};
var getDropdownFontSizeBySizeVar = (size2) => {
  switch (size2) {
    case "M":
      return "body1_400";
    case "S":
      return "body2_400";
    default:
      return "body1_400";
  }
};
var getDropdownStyleBySizeVar = (size2) => {
  switch (size2) {
    case "M":
      return css`
        padding: 4px 4px 4px 12px;
      `;
    case "S":
      return css`
        padding: 4px 4px 4px 8px;
        gap: 4px;
      `;
    default:
      return css`
        padding: 4px 4px 4px 12px;
      `;
  }
};
var getDropdownIconSizeBySizeVar = (size2) => {
  switch (size2) {
    case "S":
      return css`
        height: 24px;
        width: 24px;
        min-width: 24px;
        min-height: 24px;
      `;
    case "M":
      return css`
        height: 32px;
        width: 32px;
        min-width: 32px;
        min-height: 32px;
      `;
    default:
      return css`
        height: 32px;
        width: 32px;
        min-width: 32px;
        min-height: 32px;
      `;
  }
};
var StyledDropdown = styled6.div`
  width: ${({ width }) => width};
`;
var StyledDropdownContent = styled6.div`
  display: flex;
  flex-direction: column;
  background: ${colorTokens.neutral0};
  width: ${({ width }) => width != null ? width : "240px"};
  padding: 4px;
  border-radius: 6px;
  box-shadow: ${boxShadowTokens.dropShadow};
`;
var StyledDropdownButton = styled6.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  gap: 8px;
  cursor: pointer;
  background-color: ${colorTokens.neutral0};
  ${({ sizeVar }) => sizeVar && getDropdownStyleBySizeVar(sizeVar)};
  ${({ disabled }) => disabled && css`
      background-color: ${colorTokens.neutral100};
      cursor: not-allowed;
    `}
`;
var DropdownButtonIcon = styled6(motion.div)`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ sizeVar }) => sizeVar && getDropdownIconSizeBySizeVar(sizeVar)};
`;
var DropdownContext = createContext(null);
var useDropdown = () => {
  const context = useContext(DropdownContext);
  if (context === null) {
    throw new Error("useDropdown must be used within a DropdownProvider");
  }
  return context;
};
var getBorderColorByStatus = ({ isFocused, isError, isHovered, disabled }) => {
  if (!disabled) {
    if (isError) {
      return colorTokens.red300;
    }
    if (isFocused) {
      return colorTokens.primary300;
    }
    if (isHovered) {
      return colorTokens.neutral700;
    }
  }
  return colorTokens.neutral300;
};
var getStyleByType = ({
  type,
  height,
  minHeight,
  maxHeight,
  width,
  minWidth,
  maxWidth,
  borderRadius,
  customNumberInputHeight
}) => {
  if (type === "number") {
    return css`
      width: ${width || "64px"};
      height: ${customNumberInputHeight || "32px"};
      border-radius: ${borderRadius ? borderRadiusTokens[borderRadius] : "6px"};
    `;
  }
  return css`
    width: ${width || "100%"};
    min-width: ${minWidth || "initial"};
    max-width: ${maxWidth || "initial"};
    height: ${height || "initial"};
    min-height: ${minHeight || "initial"};
    max-height: ${maxHeight || "initial"};
    border-radius: ${borderRadius ? borderRadiusTokens[borderRadius] : "6px"};
  `;
};
var InputWrapper = styled6.label`
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 6px;
  flex-direction: ${({ direction }) => direction || "row"};
  ${({ type, height, minHeight, maxHeight, width, maxWidth, minWidth, borderRadius, customNumberInputHeight }) => getStyleByType({
  customNumberInputHeight,
  type,
  height,
  minHeight,
  maxHeight,
  width,
  maxWidth,
  minWidth,
  borderRadius
})};
  justify-content: space-between;
  gap: ${({ gap }) => gap || "8px"};
  border: 1px solid ${(props) => getBorderColorByStatus(props)};
  background-color: ${colorTokens.neutral0};
  overflow: hidden;
  ${({ disabled }) => disabled && css`
      background-color: ${colorTokens.neutral100};
      cursor: not-allowed;
    `};
`;

// src/components/Icon/Icon.types.ts
var IconSizeVariants = {
  XS: "XS",
  S: "S",
  M: "M",
  L: "L",
  XL: "XL"
};

// src/components/Icon/Icon.styled.ts
var getIconSize = (size2) => {
  switch (size2) {
    case IconSizeVariants.XS:
      return "12px";
    case IconSizeVariants.S:
      return "20px";
    case IconSizeVariants.M:
      return "24px";
    case IconSizeVariants.L:
      return "30px";
    case IconSizeVariants.XL:
      return "36px";
    default:
      return "fit-content";
  }
};
var StyledIcon = styled6.svg`
  width: ${({ sizeVar }) => sizeVar && getIconSize(sizeVar)};
  min-width: ${({ sizeVar }) => sizeVar && getIconSize(sizeVar)};
  height: ${({ sizeVar }) => sizeVar && getIconSize(sizeVar)};
  min-height: ${({ sizeVar }) => sizeVar && getIconSize(sizeVar)};
  & > path {
    fill: ${({ color }) => color && colorTokens[color]};
  }
`;
var Icon = forwardRef((_a, ref) => {
  var _b = _a, { iconSource } = _b, rest = __objRest(_b, ["iconSource"]);
  return /* @__PURE__ */ jsx(StyledIcon, __spreadProps(__spreadValues({ as: iconSource, ref }, rest), { "data-shoplflow": "Icon" }));
});
var Icon_default = Icon;
var DropdownButton = forwardRef(
  (_a, ref) => {
    var _b = _a, { width = "100%", onClick, sizeVar = "M", isError, placeholder, value, disabled, leftSource } = _b, rest = __objRest(_b, ["width", "onClick", "sizeVar", "isError", "placeholder", "value", "disabled", "leftSource"]);
    const { isOpen, setIsOpen } = useDropdown();
    const [isHovered, setIsHovered] = useState(false);
    const handleOnClick = (e) => {
      if (!disabled) {
        onClick && onClick(e);
        setIsOpen(!isOpen);
      }
    };
    const handleOnMouseEnter = () => {
      setIsHovered(true);
    };
    const handleOnMouseLeave = () => {
      setIsHovered(false);
    };
    const getTextColor = ({ value: value2, disabled: disabled2 }) => {
      if (disabled2) {
        return "neutral350";
      }
      if (!value2) {
        return "neutral400";
      }
      return "neutral700";
    };
    return /* @__PURE__ */ jsx(
      InputWrapper,
      {
        onMouseEnter: handleOnMouseEnter,
        onMouseLeave: handleOnMouseLeave,
        isFocused: isOpen,
        isHovered,
        disabled,
        width,
        isError,
        height: getDropdownHeightBySizeVar(sizeVar),
        children: /* @__PURE__ */ jsxs(StyledDropdownButton, __spreadProps(__spreadValues({ ref, onClick: handleOnClick, disabled }, rest), { sizeVar, children: [
          leftSource && leftSource,
          value || /* @__PURE__ */ jsx(
            Text_default,
            {
              typography: getDropdownFontSizeBySizeVar(sizeVar),
              color: getTextColor({ value, disabled }),
              textOverflow: "ellipsis",
              lineClamp: 1,
              children: placeholder
            }
          ),
          /* @__PURE__ */ jsx(
            DropdownButtonIcon,
            {
              sizeVar,
              animate: {
                rotate: isOpen ? 180 : 0
              },
              transition: {
                duration: 0.2
              },
              children: /* @__PURE__ */ jsx(Icon_default, { iconSource: DownArrowSolidXsmallIcon, color: "neutral400", sizeVar: "XS" })
            }
          )
        ] }))
      }
    );
  }
);
var DropdownContent = (_a) => {
  var _b = _a, { children, width: initialWidth, type, onClick } = _b, rest = __objRest(_b, ["children", "width", "type", "onClick"]);
  const { width, setIsOpen, option } = useDropdown();
  const isFillType = type === "FILL";
  const contentWidth = isFillType ? `${width}px` : initialWidth;
  const returnCallbackByOption = () => {
    if (option === "OUTSIDE_CLICK") {
      return () => setIsOpen(false);
    }
    if (option === "CLICK") {
      return () => setIsOpen(false);
    }
    return noop;
  };
  const handleClick = (e) => {
    onClick && onClick(e);
    if (option === "CLICK") {
      setIsOpen(false);
    }
  };
  return /* @__PURE__ */ jsx(OutSideClick, { outsideClick: returnCallbackByOption(), children: /* @__PURE__ */ jsx(StyledDropdownContent, __spreadProps(__spreadValues({ width: contentWidth, onClick: handleClick }, rest), { children })) });
};
var Dropdown = ({
  isOpen: initialIsOpen = false,
  trigger,
  popper,
  option = "CLICK",
  width = "100%"
}) => {
  const [triggerRef, setTriggerRef] = useState(null);
  const [size2, setSize] = useState({ width: 0, height: 0 });
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (triggerRef) {
      setSize({
        width: triggerRef.offsetWidth,
        height: triggerRef.offsetHeight
      });
    }
  }, [triggerRef]);
  useEffect(() => {
    if (initialIsOpen === void 0) {
      return;
    }
    setIsOpen(initialIsOpen);
  }, [initialIsOpen]);
  return /* @__PURE__ */ jsx(StyledDropdown, { "data-shoplflow": "Dropdown", width, children: /* @__PURE__ */ jsx(DropdownContext.Provider, { value: __spreadProps(__spreadValues({}, size2), { isOpen, setIsOpen, option }), children: /* @__PURE__ */ jsxs(
    Popper_default,
    {
      offset: 4,
      autoPlacement: {
        allowedPlacements: ["bottom-start", "top-start"]
      },
      children: [
        /* @__PURE__ */ jsx(Popper_default.Trigger, { ref: setTriggerRef, isOpen, width, children: trigger }),
        /* @__PURE__ */ jsx(Popper_default.Portal, { children: popper })
      ]
    }
  ) }) });
};
Dropdown.Button = DropdownButton;
Dropdown.Content = DropdownContent;
var Dropdown_default = Dropdown;
var Container2 = styled6.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 4px;
`;
var IconButton2 = styled6.button`
  display: flex;
  width: 16px;
  height: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: ${borderRadiusTokens.borderRadius04};
  border: none;
  background: ${({ color }) => colorTokens[color]};
  cursor: pointer;
  transition:
    transform 0.1s ease-out,
    background 0.1s ease;

  &:hover {
    background: ${({ color }) => colorTokens[getNextColor(color, 1)]};
  }
`;
var MUNUS_BUTTON_SYMBOL_KEY = Symbol("SHOPLFLOW_MUNUS_BUTTON");
var MinusButton = forwardRef((_a, ref) => {
  var _b = _a, { onClick, color = "neutral300" } = _b, rest = __objRest(_b, ["onClick", "color"]);
  return /* @__PURE__ */ jsx(Container2, { "data-shoplflow": "minusButton", children: /* @__PURE__ */ jsx(IconButton2, __spreadProps(__spreadValues({ color, onClick, ref }, rest), { children: /* @__PURE__ */ jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z",
        fill: "none"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 8C3 7.44772 3.44772 7 4 7H12C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9H4C3.44772 9 3 8.55228 3 8Z",
        fill: "white"
      }
    )
  ] }) })) });
});
MinusButton[MUNUS_BUTTON_SYMBOL_KEY] = true;
var MinusButton_default = MinusButton;
var getStylesByStyleVariant = (styleVariant, isSelected, isHovered) => {
  switch (styleVariant) {
    case "PRIMARY":
      if (isSelected) {
        return css`
          background: ${colorTokens.primary300};
          border: 1.5px solid ${colorTokens.primary300};
          & > svg > path {
            fill: ${colorTokens.neutral0};
          }
          ${isHovered && css`
            border: 1.5px solid ${colorTokens.primary400};
            background: ${colorTokens.primary400};
          `}
        `;
      }
      return css`
        background: ${colorTokens.neutral200};
        border: 1.5px solid ${colorTokens.neutral200};
        border-radius: 4px;
        ${isHovered && css`
          border: 1.5px solid ${colorTokens.neutral300};
          background: ${colorTokens.neutral300};
        `}

        & > svg > path {
          fill: ${colorTokens.neutral0};
        }
      `;
    case "LINE":
      if (isSelected) {
        return css`
          border: 1.5px solid ${colorTokens.primary300};
          background: transparent;
          border-radius: 4px;
          & > svg > path {
            fill: ${colorTokens.primary300};
          }
          ${isHovered && css`
            border: 1.5px solid ${colorTokens.primary400};
            & > svg > path {
              fill: ${colorTokens.primary400};
            }
          `}
        `;
      }
      return css`
        background: transparent;
        border: 1.5px solid ${colorTokens.neutral200};
        border-radius: 4px;
        & > svg > path {
          fill: ${colorTokens.neutral200};
        }
        ${isHovered && css`
          border: 1.5px solid ${colorTokens.neutral300};
          & > svg > path {
            fill: ${colorTokens.neutral300};
          }
        `}
      `;
    default:
      return "";
  }
};
var StyledCheckHiddenInput = styled6.input`
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  visibility: hidden;
`;
var StyledCheckbox = styled6.label`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  min-height: 16px;
  width: 16px;
  height: 16px;
  background: ${colorTokens.neutral200};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  ${({ styleVar, isSelected, isHovered }) => getStylesByStyleVariant(styleVar, isSelected, isHovered)};
  ${({ disabled }) => getDisabledStyle(disabled)}
`;
var Container3 = styled6.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  width: fit-content;
  height: fit-content;
  background-color: transparent;
`;
var CHECKBOX_SYMBOL_KEY = Symbol("SHOPLFLOW_CHECKBOX");
var Checkbox = forwardRef(
  (_a, ref) => {
    var _b = _a, { defaultSelected, isSelected, disabled, onMouseEnter, onClick, onMouseLeave, styleVar = "PRIMARY", id } = _b, rest = __objRest(_b, ["defaultSelected", "isSelected", "disabled", "onMouseEnter", "onClick", "onMouseLeave", "styleVar", "id"]);
    const [selected, toggleSelected] = useOnToggle(isSelected, defaultSelected);
    const [isHovered, toggleHovered] = useState(false);
    const handleMouseLeave = (e) => {
      toggleHovered(false);
      onMouseLeave && onMouseLeave(e);
    };
    const handleMouseEnter = (e) => {
      toggleHovered(true);
      onMouseEnter && onMouseEnter(e);
    };
    const handleClick = (e) => {
      if (disabled) {
        return;
      }
      onClick && onClick(e);
      toggleSelected();
    };
    return /* @__PURE__ */ jsxs(
      Container3,
      {
        onClick: handleClick,
        onMouseLeave: handleMouseLeave,
        onMouseEnter: handleMouseEnter,
        disabled,
        type: "button",
        "data-shoplflow": "Checkbox",
        children: [
          /* @__PURE__ */ jsx(StyledCheckHiddenInput, __spreadProps(__spreadValues({ type: "checkbox", disabled, id }, rest), { ref })),
          /* @__PURE__ */ jsx(
            StyledCheckbox,
            {
              styleVar,
              htmlFor: id,
              isHovered,
              isSelected: selected,
              disabled,
              children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "8", viewBox: "0 0 12 8", fill: "none", children: /* @__PURE__ */ jsx(
                "path",
                {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M9.78822 0.297596C10.1761 -0.0955083 10.8093 -0.0997053 11.2024 0.288222C11.5653 0.646308 11.5968 1.21334 11.2943 1.60765L11.2118 1.7024L5.31714 7.7024C4.95248 8.07193 4.37282 8.09687 3.97909 7.77976L3.88476 7.69335L0.779404 4.42669C0.396475 4.02871 0.408672 3.39567 0.806647 3.01274C1.17401 2.65926 1.74167 2.64247 2.12801 2.95499L2.2206 3.03998L4.614 5.567L9.78822 0.297596Z",
                  fill: "white"
                }
              ) })
            }
          )
        ]
      }
    );
  }
);
Checkbox[CHECKBOX_SYMBOL_KEY] = true;
var Checkbox_default = Checkbox;

// src/components/ControlButtons/Checkbox/Checkbox.types.ts
var CheckboxStyleVariants = {
  PRIMARY: "PRIMARY",
  LINE: "LINE"
};
var getSelectedStyle = (isHovered) => {
  return css`
    & > svg > circle {
      stroke: ${colorTokens.primary300};
    }
    ${isHovered && css`
      & > svg > circle {
        stroke: ${colorTokens.primary400};
      }
    `}
  `;
};
var StyledRadio = styled6.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  min-height: 16px;
  width: 16px;
  height: 16px;
  ${({ isHovered }) => css`
    & > svg > circle {
      stroke: ${colorTokens.neutral200};
    }
    ${isHovered && css`
      & > svg > circle {
        stroke: ${colorTokens.neutral300};
      }
    `}
  `}
  cursor: pointer;
  ${({ isSelected, isHovered }) => isSelected && getSelectedStyle(isHovered)}
  ${({ disabled }) => getDisabledStyle(disabled)}
`;
var Container4 = styled6.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  padding: 4px;
  width: fit-content;
  height: fit-content;
`;
var RADIO_SYMBOL_KEY = Symbol("SHOPLFLOW_RADIO");
var Radio = (_a) => {
  var _b = _a, { isSelected, defaultSelected, disabled, onClick, onMouseEnter, onMouseLeave } = _b, rest = __objRest(_b, ["isSelected", "defaultSelected", "disabled", "onClick", "onMouseEnter", "onMouseLeave"]);
  const [selected, toggleSelected] = useOnToggle(isSelected, defaultSelected);
  const [isHovered, toggleHovered] = useState(false);
  const handleMouseLeave = (e) => {
    toggleHovered(false);
    onMouseLeave && onMouseLeave(e);
  };
  const handleMouseEnter = (e) => {
    toggleHovered(true);
    onMouseEnter && onMouseEnter(e);
  };
  const handleClick = (e) => {
    if (disabled) {
      return;
    }
    onClick && onClick(e);
    toggleSelected();
  };
  return /* @__PURE__ */ jsx(
    Container4,
    __spreadProps(__spreadValues({
      onClick: handleClick,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave
    }, rest), {
      "data-shoplflow": "Radio",
      children: /* @__PURE__ */ jsx(StyledRadio, { isSelected: selected, isHovered, disabled, children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", children: /* @__PURE__ */ jsx("circle", { cx: "8", cy: "8", r: "5.5", fill: "white", stroke: "#3299FE", strokeWidth: "5" }) }) })
    })
  );
};
Radio[RADIO_SYMBOL_KEY] = true;
var Radio_default = Radio;

// src/components/Menu/Menu.styled.ts
var getStylesBySizeVar = (sizeVar) => {
  switch (sizeVar) {
    case "XS":
      return css`
        min-height: 28px;
      `;
    case "S":
      return css`
        min-height: 36px;
      `;
    case "M":
      return css`
        height: 48px;
      `;
    default:
      return css`
        height: 48px;
      `;
  }
};
var getFontStylesBySizeVar = (sizeVar) => {
  switch (sizeVar) {
    case "XS":
      return "body2_400";
    case "S":
      return "body1_400";
    case "M":
      return "body1_400";
    default:
      return "body1_400";
  }
};
var StyledMenu = styled6.li`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  padding: 6px;
  gap: 4px;
  border-radius: 4px;
  cursor: pointer;
  background: transparent;
  ${({ sizeVar }) => getStylesBySizeVar(sizeVar)};
  &:hover {
    background: ${colorTokens.neutral400_5};
  }
  ${({ disabled }) => disabled && getDisabledStyle(disabled)}
  ${({ isSelected, leftSource }) => isSelected === true && (!leftSource || leftSource && !leftSource.type[RADIO_SYMBOL_KEY] && !leftSource.type[CHECKBOX_SYMBOL_KEY] && !leftSource.type[MUNUS_BUTTON_SYMBOL_KEY]) && css`
      background: ${colorTokens.neutral200};
      &:hover {
        background: ${colorTokens.neutral200};
      }
    `}
`;
var Menu = (_a) => {
  var _b = _a, {
    leftSource,
    rightSource,
    children,
    isSelected,
    defaultSelected = false,
    onClick,
    sizeVar = "XS",
    disabled = false
  } = _b, rest = __objRest(_b, [
    "leftSource",
    "rightSource",
    "children",
    "isSelected",
    "defaultSelected",
    "onClick",
    "sizeVar",
    "disabled"
  ]);
  const [selected, handleToggle] = useOnToggle(isSelected, defaultSelected);
  const LeftSourceClone = leftSource ? React3__default.cloneElement(leftSource, __spreadProps(__spreadValues({}, rest), {
    isSelected
  })) : leftSource;
  const handleOnClick = (e) => {
    !disabled && handleToggle();
    !disabled && onClick && onClick(e);
  };
  return /* @__PURE__ */ jsxs(
    StyledMenu,
    __spreadProps(__spreadValues({
      sizeVar,
      isSelected: selected,
      leftSource,
      onClick: handleOnClick
    }, rest), {
      "data-shoplflow": "Menu",
      children: [
        leftSource && LeftSourceClone,
        /* @__PURE__ */ jsx(Stack_default.Horizontal, { width: "100%", height: "100%", align: "center", className: getFontStylesBySizeVar(sizeVar), children }),
        rightSource && rightSource
      ]
    })
  );
};
var Menu_default = Menu;

// src/components/Menu/Menu.types.ts
var MenuSizeVariants = {
  XS: "XS",
  S: "S",
  M: "M"
};
var StyledList = styled6.li`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  padding: 6px 8px;
  gap: 4px;
  border-radius: 8px;
  background: ${colorTokens.neutral0};
  cursor: pointer;
  ${({ disabled }) => disabled && getDisabledStyle(disabled)}
  &:hover {
    background: ${colorTokens.neutral100};
  }
`;
var StyledText2Rows = styled6.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
`;
var List = (_a) => {
  var _b = _a, { children, leftSource, rightSource } = _b, rest = __objRest(_b, ["children", "leftSource", "rightSource"]);
  const LeftSourceClone = leftSource ? React3__default.cloneElement(leftSource, __spreadValues({}, rest)) : leftSource;
  if (!children && rightSource) {
    throw new Error("RightSource\uB294 children\uC774 \uD544\uC218\uB85C \uD3EC\uD568\uB418\uC5B4\uC57C\uD569\uB2C8\uB2E4.");
  }
  return /* @__PURE__ */ jsxs(StyledList, __spreadProps(__spreadValues({ "data-shoplflow": "List" }, rest), { children: [
    LeftSourceClone && LeftSourceClone,
    /* @__PURE__ */ jsx(Stack_default.Horizontal, { height: "36px", width: "100%", spacing: "spacing08", align: "center", children }),
    rightSource && rightSource
  ] }));
};
var Text2Rows = ({ title, subTitle }) => {
  return /* @__PURE__ */ jsxs(StyledText2Rows, { children: [
    /* @__PURE__ */ jsx(Text_default, { typography: "body1_500", color: "neutral700", lineClamp: 1, wordBreak: "break-all", children: title }),
    subTitle && /* @__PURE__ */ jsx(Text_default, { typography: "body2_400", color: "neutral400", lineClamp: 1, wordBreak: "break-all", children: subTitle })
  ] });
};
List.Text2Rows = Text2Rows;
var List_default = List;
var getTypographyBySize = (size2) => {
  switch (size2) {
    case "XS":
      return "caption_400";
    case "S":
      return "caption_400";
    case "M":
      return "body2_400";
    default:
      return "body2_400";
  }
};
var getTagStyleBySize = (size2) => {
  switch (size2) {
    case "XS":
      return css`
        height: 20px;
        padding: 0 4px;
        border-radius: 4px;
      `;
    case "S":
      return css`
        height: 24px;
        padding: 0 8px;
        border-radius: 4px;
      `;
    case "M":
      return css`
        padding: 4px 8px;
        height: 32px;
        border-radius: 6px;
      `;
    default:
      return css`
        padding: 4px 8px;
        height: 32px;
      `;
  }
};
var getRadiusBySize = (size2) => {
  switch (size2) {
    case "XS":
      return css`
        border-radius: 12px;
      `;
    case "S":
      return css`
        border-radius: 16px;
      `;
    case "M":
      return css`
        border-radius: 16px;
      `;
    default:
      return css`
        border-radius: 16px;
      `;
  }
};
var getColorsByStyleVariant = (styleVariant, color = "neutral700", background2) => {
  switch (styleVariant) {
    case "SOLID":
      return css`
        background: ${colorTokens[color]};
        color: ${colorTokens.neutral0};
      `;
    case "TINT":
      return css`
        background: ${background2 ? colorTokens[background2] : colorTokens[getNextColor(color, -2)]};
        color: ${colorTokens[color]};
      `;
    case "LINE":
      return css`
        background: transparent;
        color: ${colorTokens[color]};
        border: 1px solid ${colorTokens[color]};
      `;
    default:
      return css`
        background: ${colorTokens[color]};
        color: ${colorTokens.neutral0};
      `;
  }
};
var StyledTag = styled6.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: default;
  gap: 2px;
  ${({ sizeVar }) => getTagStyleBySize(sizeVar)};
  ${({ color, styleVar, background: background2 }) => getColorsByStyleVariant(styleVar, color, background2)};
  ${({ radius, sizeVar }) => radius && getRadiusBySize(sizeVar)};
`;

// src/components/Tag/Tag.tsx
var import_classnames = __toESM(require_classnames(), 1);
var Tag = (_a) => {
  var _b = _a, { sizeVar, children, rightSource, leftSource, className } = _b, rest = __objRest(_b, ["sizeVar", "children", "rightSource", "leftSource", "className"]);
  return /* @__PURE__ */ jsxs(
    StyledTag,
    __spreadProps(__spreadValues({
      sizeVar,
      className: (0, import_classnames.default)(getTypographyBySize(sizeVar), className)
    }, rest), {
      "data-shoplflow": "Tag",
      children: [
        leftSource && leftSource,
        children,
        rightSource && rightSource
      ]
    })
  );
};
var Tag_default = Tag;

// src/components/Tag/Tag.types.ts
var TagStyleVariants = {
  SOLID: "SOLID",
  TINT: "TINT",
  LINE: "LINE"
};
var TagSizeVariants = {
  XS: "XS",
  S: "S",
  M: "M"
};
var StyledTree = styled6(motion.ul)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
var StyledTreeItem = styled6(motion.li)`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 48px;
  gap: 4px;
  align-items: center;
  justify-content: space-between;
  padding: 8px 8px 8px 0;
  border-radius: 8px;
  background: transparent;
  cursor: ${({ onClick }) => onClick ? "pointer" : "initial"};
  ${({ depth }) => depth && css`
      padding-left: ${depth * 16}px;
    `};
  &:hover {
    background: ${colorTokens.neutral400_5};
  }
  ${({ disabled }) => disabled && getDisabledStyle(disabled)}
`;
var LeftElementWrapper = styled6.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
var RightElementWrapper = styled6.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
var IconWrapper = styled6(motion.div)`
  display: flex;
  width: fit-content;
  height: fit-content;
`;

// src/components/Tree/Tree.types.ts
var TREE_SYMBOL_KEY = Symbol("SHOPLFLOW_TREE");

// src/animation/AnimateKey.ts
var AnimateKey = {
  initial: "initial",
  animate: "animate",
  exit: "exit"
};
var Tree = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  const [isMounted, setIsMounted] = React3__default.useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  if (!isMounted) {
    return null;
  }
  return /* @__PURE__ */ jsx(StyledTree, __spreadProps(__spreadValues({}, rest), { "data-shoplflow": "Tree", layout: true, layoutRoot: true, children: /* @__PURE__ */ jsx(LayoutGroup, { children: /* @__PURE__ */ jsx(AnimatePresence, { mode: "sync", children }) }) }));
};
var TreeItem = (_a) => {
  var _b = _a, {
    children,
    label,
    leftSource,
    rightSource,
    depth = 0,
    initialIsOpen,
    isOpen,
    disabled = false,
    onClick
  } = _b, rest = __objRest(_b, [
    "children",
    "label",
    "leftSource",
    "rightSource",
    "depth",
    "initialIsOpen",
    "isOpen",
    "disabled",
    "onClick"
  ]);
  const [isOpened, setIsOpened] = React3__default.useState(initialIsOpen != null ? initialIsOpen : false);
  const CloneChildren = React3__default.Children.map(children, (child) => {
    if (!React3__default.isValidElement(child)) {
      return child;
    }
    if (child.type[TREE_SYMBOL_KEY]) {
      return React3__default.cloneElement(child, {
        depth: depth + 1
      });
    }
    return child;
  });
  const handleToggle = (e) => {
    e.stopPropagation();
    setIsOpened((prev) => !prev);
  };
  const handleClickTreeItem = (e) => {
    if (disabled || !onClick) {
      return;
    }
    return onClick(e);
  };
  const LeftSourceClone = leftSource ? React3__default.cloneElement(leftSource, __spreadValues({
    disabled,
    onClick
  }, rest)) : leftSource;
  useEffect(() => {
    if (isOpen !== void 0) {
      setIsOpened(isOpen);
    }
  }, [isOpen]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ createElement(
      StyledTreeItem,
      __spreadValues(__spreadProps(__spreadValues({
        disabled,
        depth,
        variants: fadeInOut
      }, AnimateKey), {
        layout: true,
        key: String(label),
        onClick: handleClickTreeItem
      }), rest),
      /* @__PURE__ */ jsxs(LeftElementWrapper, { children: [
        LeftSourceClone && LeftSourceClone,
        /* @__PURE__ */ jsx(StackContainer_default, { padding: "0 0 0 4px", children: /* @__PURE__ */ jsx(Text_default, { typography: "body1_400", lineClamp: 1, color: disabled ? "neutral350" : "neutral700", children: label }) })
      ] }),
      /* @__PURE__ */ jsxs(RightElementWrapper, { children: [
        rightSource,
        children && /* @__PURE__ */ jsx(IconButton_default, { styleVar: "GHOST", onClick: handleToggle, sizeVar: "S", children: /* @__PURE__ */ jsx(
          IconWrapper,
          {
            animate: {
              rotate: isOpened ? 180 : 0,
              transition: {
                duration: 0.2
              }
            },
            children: /* @__PURE__ */ jsx(Icon_default, { iconSource: DownArrowIcon, sizeVar: "S", color: "neutral400" })
          }
        ) })
      ] })
    ),
    /* @__PURE__ */ jsx(AnimatePresence, { mode: "sync", children: isOpened && children && /* @__PURE__ */ jsx(motion.div, __spreadProps(__spreadValues({ layout: true }, AnimateKey), { variants: fadeInOut, children: CloneChildren }), "children" + String(CloneChildren)) })
  ] });
};
TreeItem[TREE_SYMBOL_KEY] = true;
Tree.Item = TreeItem;
var Tree_default = Tree;
var StyledInput = styled6.input`
  padding: 4px 0 4px 12px;
  background-color: transparent;
  display: flex;
  min-width: ${({ minWidth }) => minWidth || "64px"};
  width: 100%;
  border: none;
  box-sizing: border-box;
  &::placeholder {
    color: ${colorTokens.neutral350};
  }
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ${({ disabled }) => disabled && css`
      color: ${colorTokens.neutral350};
      cursor: not-allowed;
    `};
  /* Firefox */
  &[type='number'] {
    padding: 4px 8px;
    text-align: center;
    -moz-appearance: textfield;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
`;
var RightElementWrapper2 = styled6.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 8px 0 0;
`;
var Wrapper = styled6.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  gap: 2px;
`;
var TextCounter = ({ currentLength, maxLength }) => {
  return /* @__PURE__ */ jsxs(Wrapper, { children: [
    /* @__PURE__ */ jsx(Text_default, { typography: "caption_400", color: "neutral400", children: currentLength }),
    /* @__PURE__ */ jsx(Text_default, { typography: "caption_400", color: "neutral350", children: "/" }),
    /* @__PURE__ */ jsx(Text_default, { typography: "caption_400", color: "neutral350", children: maxLength })
  ] });
};
var TextCounter_default = TextCounter;
createContext({
  domain: "SHOPL",
  handleToggleTheme: () => {
  }
});

// src/styles/IconAssets.tsx
var assetFunction = (iconName, domainProps) => {
  const domain = domainProps != null ? domainProps : getDomain();
  const HadaIcon = HadaAssets[iconName];
  const ShoplIcon = ShoplAssets[iconName];
  return domain === "hada" ? HadaIcon : ShoplIcon;
};

// src/components/Inputs/Input/utils/getNumberLimiteRange.ts
var getNumberLimitRange = (value, min, max) => {
  if (min && value < min) {
    return String(min);
  }
  if (max && value > max) {
    return String(max);
  }
  return String(value);
};
var Input = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      onFocus,
      onBlur,
      onChange,
      onClear,
      defaultValue,
      value,
      isError,
      disabled,
      type: initialType,
      maxLength,
      min,
      max,
      className,
      width,
      borderRadius,
      customNumberInputHeight,
      onKeyDown,
      sizeVar = "M",
      rightSource,
      minWidth,
      gap,
      initIsFocused
    } = _b, rest = __objRest(_b, [
      "onFocus",
      "onBlur",
      "onChange",
      "onClear",
      "defaultValue",
      "value",
      "isError",
      "disabled",
      "type",
      "maxLength",
      "min",
      "max",
      "className",
      "width",
      "borderRadius",
      "customNumberInputHeight",
      "onKeyDown",
      "sizeVar",
      "rightSource",
      "minWidth",
      "gap",
      "initIsFocused"
    ]);
    const [text, setText] = useState("");
    const [isFocused, setIsFocused] = useState(Boolean(initIsFocused));
    const [type, setType] = useState(initialType);
    const [isHovered, setIsHovered] = useState(false);
    const uniqueId = useId();
    const inputRef = React3__default.useRef(null);
    const refs = useMergeRefs2(ref, inputRef);
    const convertToString = useCallback((value2) => {
      if (typeof value2 !== "number") {
        return typeof value2 === "string" ? value2 : value2.join("");
      }
      return String(value2);
    }, []);
    const sliceText = useCallback(
      (value2) => {
        if (maxLength && value2.length > maxLength) {
          return value2.slice(0, maxLength);
        }
        return value2;
      },
      [maxLength]
    );
    const handleOnMouseEnter = () => {
      setIsHovered(true);
    };
    const handleOnMouseLeave = () => {
      setIsHovered(false);
    };
    const handleOnFocus = (event) => {
      onFocus && onFocus(event);
      setIsFocused(true);
    };
    const handleOnBlur = (event) => {
      onBlur && onBlur(event);
      !isHovered && setIsFocused(false);
    };
    const handleOnKeyDown = (event) => {
      if (event.code === "Tab") {
        setIsFocused(false);
      }
      onKeyDown && onKeyDown(event);
    };
    const handleOnChange = (event) => {
      onChange && onChange(event);
      const slicedText = sliceText(event.target.value);
      if (type === "number") {
        const numberValue = Number(slicedText);
        const numberMin = Number(min);
        const numberMax = Number(max);
        const limitedText = getNumberLimitRange(numberValue, numberMin, numberMax);
        setText(limitedText);
        return;
      }
      setText(slicedText);
    };
    const handleOnClear = () => {
      onClear && onClear();
      if (inputRef.current) {
        setText("");
        inputRef.current.value = "";
      }
    };
    const handleTogglePasswordType = () => {
      if (type === "password") {
        setType("text");
      } else {
        setType("password");
      }
    };
    useEffect(() => {
      if (defaultValue !== void 0) {
        const convertString = convertToString(defaultValue);
        const slicedText = sliceText(convertString);
        setText(slicedText);
      }
    }, [convertToString, defaultValue, maxLength, sliceText]);
    useEffect(() => {
      var _a2;
      if (value !== void 0) {
        const convertString = convertToString(value);
        const slicedText = sliceText(convertString);
        ((_a2 = inputRef.current) == null ? void 0 : _a2.value) && (inputRef.current.value = slicedText);
        setText(slicedText);
      }
    }, [convertToString, maxLength, sliceText, value]);
    useEffect(() => {
      setType(initialType);
    }, [initialType]);
    const height = sizeVar === "M" ? "40px" : "32px";
    useEffect(() => {
      if (typeof initIsFocused === "undefined") {
        return;
      }
      setIsFocused(initIsFocused);
    }, [initIsFocused]);
    return /* @__PURE__ */ jsxs(
      InputWrapper,
      {
        htmlFor: uniqueId,
        isFocused,
        disabled,
        isError,
        isHovered,
        onMouseEnter: handleOnMouseEnter,
        onMouseLeave: handleOnMouseLeave,
        type,
        width,
        height,
        maxHeight: height,
        "data-shoplflow": "input",
        borderRadius,
        customNumberInputHeight,
        gap,
        children: [
          /* @__PURE__ */ jsx(
            StyledInput,
            __spreadValues({
              onFocus: handleOnFocus,
              onBlur: handleOnBlur,
              onChange: handleOnChange,
              onKeyDown: handleOnKeyDown,
              maxLength,
              disabled,
              value: text,
              type,
              id: uniqueId,
              ref: refs,
              minWidth,
              className: "body1_400" + (className ? ` ${className}` : "")
            }, rest)
          ),
          !(type === "number") && /* @__PURE__ */ jsxs(RightElementWrapper2, { children: [
            maxLength && isFocused && /* @__PURE__ */ jsx(TextCounter_default, { currentLength: String(text).length, maxLength }),
            isFocused && Boolean(String(text).length > 0) && /* @__PURE__ */ jsx(IconButton_default, { sizeVar: "S", onClick: handleOnClear, styleVar: "GHOST", children: /* @__PURE__ */ jsx(Icon_default, { iconSource: assetFunction("DeleteIcon"), color: "neutral350" }) }),
            initialType === "password" && /* @__PURE__ */ jsx(IconButton_default, { sizeVar: "S", onClick: handleTogglePasswordType, styleVar: "GHOST", children: /* @__PURE__ */ jsx(
              Icon_default,
              {
                color: "neutral600",
                iconSource: assetFunction(type === "password" ? "ViewOffIcon" : "ViewOnIcon")
              }
            ) })
          ] }),
          rightSource && rightSource
        ]
      }
    );
  }
);
var Input_default = Input;

// src/components/Inputs/Input/Input.types.ts
var InputSizeVariants = {
  S: "S",
  M: "M"
};
var StyledInputButton = styled6.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: ${colorTokens.neutral0};
  gap: 4px;
  padding: 4px 4px 4px 12px;
  cursor: pointer;
  ${({ disabled }) => disabled && css`
      background-color: ${colorTokens.neutral100};
      cursor: not-allowed;
    `}
`;
var StyledInputButtonContent = styled6.input`
  display: flex;
  width: 100%;
  border: none;
  box-sizing: border-box;
  caret-color: transparent;
  &::placeholder {
    color: ${colorTokens.neutral350};
  }
`;
var InputButton = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      value,
      defaultValue,
      onChange,
      onClick,
      isSelected,
      disabled = false,
      useClear = true,
      rightSource,
      onClear,
      width = "100%"
    } = _b, rest = __objRest(_b, [
      "value",
      "defaultValue",
      "onChange",
      "onClick",
      "isSelected",
      "disabled",
      "useClear",
      "rightSource",
      "onClear",
      "width"
    ]);
    var _a2, _b2;
    const [text, setText] = useState((_a2 = value != null ? value : defaultValue) != null ? _a2 : "");
    const [isHovered, setIsHovered] = useState(false);
    const prevValue = useRef((_b2 = value != null ? value : defaultValue) != null ? _b2 : "");
    const convertToString = useCallback((value2) => {
      if (typeof value2 !== "number") {
        return typeof value2 === "string" ? value2 : value2.join("");
      }
      return String(value2);
    }, []);
    const handleOnClick = (e) => {
      if (!disabled) {
        onClick && onClick(e);
      }
    };
    const handleOnClear = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!disabled) {
        onClear && onClear(e);
        setText("");
      }
    };
    const handleOnMouseEnter = () => {
      setIsHovered(true);
    };
    const handleOnMouseLeave = () => {
      setIsHovered(false);
    };
    useEffect(() => {
      if (prevValue.current === value) {
        return;
      }
      if (value || value === "") {
        const convertString = convertToString(value);
        setText(convertString);
        prevValue.current = convertString;
      }
    }, [convertToString, value]);
    useEffect(() => {
      if (prevValue.current === value) {
        return;
      }
      onChange && onChange(convertToString(text));
    }, [convertToString, onChange, value, text]);
    return /* @__PURE__ */ jsx(
      InputWrapper,
      {
        onMouseEnter: handleOnMouseEnter,
        onMouseLeave: handleOnMouseLeave,
        "data-shoplflow": "InputButton",
        isHovered,
        isFocused: isSelected,
        disabled,
        minHeight: "40px",
        maxHeight: "40px",
        width,
        children: /* @__PURE__ */ jsxs(StyledInputButton, { onClick: handleOnClick, disabled, children: [
          /* @__PURE__ */ jsx(StyledInputButtonContent, __spreadValues({ className: "body1_400", value: text, ref }, rest)),
          /* @__PURE__ */ jsxs(Stack_default.Horizontal, { align: "center", children: [
            useClear && text && /* @__PURE__ */ jsx(IconButton_default, { sizeVar: "S", onClick: handleOnClear, styleVar: "GHOST", disabled, children: /* @__PURE__ */ jsx(Icon_default, { iconSource: assetFunction("DeleteIcon"), color: "neutral350" }) }),
            rightSource
          ] })
        ] })
      }
    );
  }
);
var InputButton_default = InputButton;
var BottomElementWrapper = styled6.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  padding: 8px 12px;
  gap: 8px;
  background-color: ${colorTokens.neutral0};
`;
var StyledTextarea = styled6.textarea`
  padding: 8px 12px 0 12px;
  background-color: transparent;
  resize: none;
  width: 100%;
  height: 100%;
  flex: 1;
  word-break: break-all;
  ${({ disabled }) => getDisabledStyle(disabled)};
  &::placeholder {
    color: ${colorTokens.neutral350};
  }
`;
var TextArea = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      name,
      maxLength,
      placeholder,
      disabled = false,
      isError = false,
      onChange,
      value,
      defaultValue,
      onBlur,
      onFocus,
      minHeight = "100px",
      width,
      height,
      className
    } = _b, rest = __objRest(_b, [
      "name",
      "maxLength",
      "placeholder",
      "disabled",
      "isError",
      "onChange",
      "value",
      "defaultValue",
      "onBlur",
      "onFocus",
      "minHeight",
      "width",
      "height",
      "className"
    ]);
    const [text, setText] = useState("");
    const [isFocused, setIsFocused] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const handleOnMouseEnter = () => {
      setIsHovered(true);
    };
    const handleOnMouseLeave = () => {
      setIsHovered(false);
    };
    const handleOnFocus = (event) => {
      onFocus && onFocus(event);
      setIsFocused(true);
    };
    const handleOnBlur = (event) => {
      onBlur && onBlur(event);
      !isHovered && setIsFocused(false);
    };
    const handleOnChange = (event) => {
      onChange && onChange(event);
      setText(event.target.value);
    };
    const convertToString = (value2) => {
      if (typeof value2 !== "number") {
        return typeof value2 === "string" ? value2 : value2.join("");
      }
      return String(value2);
    };
    useEffect(() => {
      if (defaultValue) {
        const convertString = convertToString(defaultValue);
        if (maxLength && convertString.length > maxLength) {
          setText(convertString);
        }
        setText(convertString);
      }
    }, [defaultValue, maxLength]);
    useEffect(() => {
      if (value) {
        const convertString = convertToString(value);
        if (maxLength && convertString.length > maxLength) {
          setText(convertString);
        }
        setText(convertToString(value));
      }
    }, [maxLength, value]);
    const uniqueId = useId();
    return /* @__PURE__ */ jsxs(
      InputWrapper,
      {
        htmlFor: uniqueId,
        isFocused,
        disabled,
        isHovered,
        isError,
        direction: "column",
        onMouseEnter: handleOnMouseEnter,
        onMouseLeave: handleOnMouseLeave,
        height,
        minHeight,
        width,
        "data-shoplflow": "text-area",
        children: [
          /* @__PURE__ */ jsx(
            StyledTextarea,
            __spreadValues({
              className: "body1_400" + (className ? ` ${className}` : ""),
              placeholder,
              onFocus: handleOnFocus,
              onBlur: handleOnBlur,
              onChange: handleOnChange,
              name,
              id: uniqueId,
              value,
              ref,
              maxLength,
              disabled
            }, rest)
          ),
          /* @__PURE__ */ jsx(BottomElementWrapper, { children: maxLength && /* @__PURE__ */ jsx(TextCounter_default, { currentLength: String(text).length, maxLength }) })
        ]
      }
    );
  }
);
var TextArea_default = TextArea;
var StyledSelectInputButton = styled6.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: ${colorTokens.neutral0};
  gap: 4px;
  padding: 4px 4px 4px 12px;
  cursor: pointer;
  ${({ disabled }) => disabled && css`
      background-color: ${colorTokens.neutral100};
      cursor: not-allowed;
    `}
`;
var SelectInputButton = (_a) => {
  var _b = _a, {
    disabled,
    isSelected,
    onMouseEnter,
    onMouseLeave,
    onClick,
    onClear,
    value,
    placeholder,
    label,
    width = "100%",
    rightSource
  } = _b, rest = __objRest(_b, [
    "disabled",
    "isSelected",
    "onMouseEnter",
    "onMouseLeave",
    "onClick",
    "onClear",
    "value",
    "placeholder",
    "label",
    "width",
    "rightSource"
  ]);
  const [isHovered, setIsHovered] = useState(false);
  const handleOnClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled) {
      onClick && onClick(e);
    }
  };
  const handleOnClear = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled) {
      onClear && onClear(e);
    }
  };
  const handleOnMouseEnter = (e) => {
    setIsHovered(true);
    onMouseEnter && onMouseEnter(e);
  };
  const handleOnMouseLeave = (e) => {
    setIsHovered(false);
    onMouseLeave && onMouseLeave(e);
  };
  return /* @__PURE__ */ jsx(
    InputWrapper,
    __spreadProps(__spreadValues({
      onMouseEnter: handleOnMouseEnter,
      onMouseLeave: handleOnMouseLeave,
      onClick: handleOnClick,
      isHovered,
      isFocused: isSelected,
      disabled,
      width,
      minHeight: "40px"
    }, rest), {
      "data-shoplflow": "SelectInputButton",
      children: /* @__PURE__ */ jsxs(StyledSelectInputButton, { children: [
        value && value.length > 0 && label ? /* @__PURE__ */ jsx(Text_default, { typography: "body1_400", lineClamp: 1, children: value[0][label] }) : /* @__PURE__ */ jsx(Text_default, { typography: "body1_400", lineClamp: 1, color: "neutral350", children: placeholder }),
        /* @__PURE__ */ jsxs(Stack_default.Horizontal, { align: "center", spacing: "spacing04", children: [
          value && value.length > 1 && /* @__PURE__ */ jsxs(Text_default, { typography: "body1_400", color: "neutral700", children: [
            "+",
            value.length - 1
          ] }),
          /* @__PURE__ */ jsxs(Stack_default.Horizontal, { align: "center", children: [
            value && value.length > 0 && /* @__PURE__ */ jsx(IconButton_default, { sizeVar: "S", onClick: handleOnClear, styleVar: "GHOST", disabled, children: /* @__PURE__ */ jsx(Icon_default, { iconSource: assetFunction("DeleteIcon"), color: "neutral350" }) }),
            rightSource
          ] })
        ] })
      ] })
    })
  );
};
var SelectInputButton_default = SelectInputButton;
var StyledTooltipContent = styled6.div`
  background-color: ${colorTokens.neutral700};
  padding: 4px 8px;
  max-width: 240px;
  border-radius: 4px;
`;
var TooltipContent = (_a) => {
  var _b = _a, { content } = _b, args = __objRest(_b, ["content"]);
  return /* @__PURE__ */ jsx(StyledTooltipContent, __spreadProps(__spreadValues({}, args), { children: /* @__PURE__ */ jsx(Text_default, { typography: "caption_400", color: "neutral0", wordBreak: "break-all", children: content }) }));
};
var Tooltip = (_a) => {
  var _b = _a, {
    open,
    onOpenChange,
    trigger,
    popper,
    placement = "bottom-start",
    offset: offset4 = 4,
    triggerRef,
    portalRef
  } = _b, popperProps = __objRest(_b, [
    "open",
    "onOpenChange",
    "trigger",
    "popper",
    "placement",
    "offset",
    "triggerRef",
    "portalRef"
  ]);
  const [isOpen, setIsOpen] = useState(false);
  const showHandler = useCallback(() => {
    if (open === void 0) {
      setIsOpen(true);
    }
    onOpenChange == null ? void 0 : onOpenChange(true);
  }, [open, onOpenChange]);
  const hideHandler = useCallback(() => {
    if (open === void 0) {
      setIsOpen(false);
    }
    onOpenChange == null ? void 0 : onOpenChange(false);
  }, [open, onOpenChange]);
  return /* @__PURE__ */ jsxs(Popper_default, __spreadProps(__spreadValues({ offset: offset4, placement, middlewares: [flip(), shift({ padding: 5 })] }, popperProps), { children: [
    /* @__PURE__ */ jsx(
      Popper_default.Trigger,
      {
        ref: triggerRef,
        isOpen: isOpen || open,
        onMouseOver: showHandler,
        onMouseLeave: hideHandler,
        onFocus: showHandler,
        onBlur: hideHandler,
        style: { display: "flex", alignItems: "center", justifyContent: "center" },
        children: trigger
      }
    ),
    /* @__PURE__ */ jsx(Popper_default.Portal, { ref: portalRef, children: popper })
  ] }));
};
Tooltip.Content = TooltipContent;
var Tooltip_default = Tooltip;
var TabsContext = createContext(null);
var useTabs = () => {
  const context = useContext(TabsContext);
  if (context === null) {
    throw new Error("useTabs should be used in Tabs");
  }
  return context;
};
var getHoverTabStyleByStyleVar = (styleVar) => {
  switch (styleVar) {
    case "INFO": {
      return css`
        ::after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          bottom: -2px;
          height: 2px;
          background: ${colorTokens.neutral500};
        }
      `;
    }
    default: {
      return null;
    }
  }
};
var getWrapperStyleByStyleVar = (styleVar) => {
  switch (styleVar) {
    case "INFO": {
      return css`
        padding-inline: 16px;
      `;
    }
    default: {
      return null;
    }
  }
};
var getActiveTriggerStyleByStyleVar = (styleVar) => {
  switch (styleVar) {
    case "INFO": {
      return css`
        ::after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          bottom: -2px;
          height: 2px;
          background: #000;
        }
      `;
    }
    default: {
      return null;
    }
  }
};
var StyledTab = styled6.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  width: fit-content;
  cursor: pointer;
  position: relative;
  user-select: none;

  ${({ styleVar }) => styleVar && getWrapperStyleByStyleVar(styleVar)};

  /* hover style */
  ${({ isActive, isHover, styleVar }) => !isActive && isHover && styleVar && getHoverTabStyleByStyleVar(styleVar)}

  /* active style */
  ${({ isActive, styleVar }) => isActive && styleVar && getActiveTriggerStyleByStyleVar(styleVar)}
`;
var getTextStyleByStyleVar = (styleVar) => {
  switch (styleVar) {
    case "NORMAL": {
      return css`
        color: ${colorTokens.neutral400};
      `;
    }
    case "INFO": {
      return css`
        color: ${colorTokens.neutral500};
      `;
    }
  }
};
var getHoverTextStyleByStyleVar = (styleVar) => {
  switch (styleVar) {
    case "NORMAL": {
      return css`
        color: ${colorTokens.neutral500};
      `;
    }
    case "INFO": {
      return css`
        color: ${colorTokens.neutral700};
      `;
    }
    default: {
      return null;
    }
  }
};
var getActiveTextStyleByStyleVar = (styleVar, activeColor) => {
  switch (styleVar) {
    case "NORMAL": {
      return css`
        color: ${activeColor ? colorTokens[activeColor] : colorTokens.neutral700};
      `;
    }
    case "INFO": {
      return css`
        color: ${colorTokens.neutral700};
      `;
    }
    default: {
      return css`
        color: ${colorTokens.primary300};
      `;
    }
  }
};
var StyledTabText = styled6(Text_default)`
  cursor: pointer;

  ${({ styleVar }) => styleVar && getTextStyleByStyleVar(styleVar)};

  /* hover style */
  ${({ isHover, styleVar, isActive }) => !isActive && isHover && styleVar && getHoverTextStyleByStyleVar(styleVar)}

  /* active style */
  ${({ isActive, styleVar, activeColor }) => isActive && styleVar && getActiveTextStyleByStyleVar(styleVar, activeColor)}
`;
var StyledIndicator = styled6(motion.div)`
  position: absolute;
  bottom: -2px;
  left: 0px;
  right: 0px;
  height: 2px;
  background-color: black;
  width: 100%;
`;
var Indicator = ({ layoutId }) => {
  return /* @__PURE__ */ jsx(StyledIndicator, { layoutId, transition: { duration: 0.2 } });
};
var Tab = (_a) => {
  var _b = _a, {
    value,
    label,
    leftSource,
    rightSource,
    as,
    styleVar = "NORMAL",
    sizeVar = "L",
    onClick,
    activeColor
  } = _b, args = __objRest(_b, [
    "value",
    "label",
    "leftSource",
    "rightSource",
    "as",
    "styleVar",
    "sizeVar",
    "onClick",
    "activeColor"
  ]);
  const { activeTab, setActiveTab } = useTabs();
  const [isHover, setIsHover] = useState(false);
  const isActive = value === activeTab;
  const hoverHandler = useCallback(() => {
    setIsHover(true);
  }, []);
  const unhoverHandler = useCallback(() => {
    setIsHover(false);
  }, []);
  const clickHandler = (event) => {
    onClick == null ? void 0 : onClick(event);
    setActiveTab(value);
  };
  let typography = "title1_700";
  if (styleVar === "INFO") {
    typography = "body1_700";
  }
  if (styleVar === "NORMAL" && sizeVar === "M") {
    typography = "title2_700";
  }
  return /* @__PURE__ */ jsxs(
    StyledTab,
    __spreadProps(__spreadValues({
      isActive,
      as,
      onClick: clickHandler,
      onMouseOver: hoverHandler,
      onMouseLeave: unhoverHandler,
      onFocus: hoverHandler,
      onBlur: unhoverHandler,
      isHover,
      styleVar
    }, args), {
      children: [
        leftSource,
        /* @__PURE__ */ jsx(
          StyledTabText,
          {
            isHover,
            lineClamp: 2,
            typography: `${typography}`,
            isActive,
            activeColor,
            styleVar,
            children: label
          }
        ),
        rightSource,
        styleVar === "INFO" && isActive && /* @__PURE__ */ jsx(Indicator, { layoutId: "underline" })
      ]
    })
  );
};
var Tabs = ({ children, initialTab, onChange }) => {
  const [activeTab, setActiveTab] = useState(initialTab);
  useEffect(() => {
    if (!onChange || !activeTab) {
      return;
    }
    onChange(activeTab);
  }, [activeTab]);
  return /* @__PURE__ */ jsx(
    TabsContext.Provider,
    {
      value: {
        activeTab,
        setActiveTab
      },
      children: /* @__PURE__ */ jsx(LayoutGroup, { children: /* @__PURE__ */ jsx(AnimatePresence, { children }) })
    }
  );
};
Tabs.Tab = Tab;
var Tabs_default = Tabs;

// src/components/Tabs/Tabs.types.ts
var TabStyleVariants = {
  NORMAL: "NORMAL",
  INFO: "INFO"
};
var TabSizeVariants = {
  M: "M",
  L: "L"
};
var PaginationWrapper = styled6.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;
var StyledPagination = styled6.nav`
  display: flex;
  align-items: center;
`;
var PageItem = styled6.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: ${borderRadiusTokens.borderRadius08};
  background-color: ${({ isActive }) => isActive ? colorTokens.neutral300 : colorTokens.neutral0};
  cursor: pointer;

  &:hover {
    background-color: ${({ isActive }) => isActive ? colorTokens.neutral300 : colorTokens.neutral100};
  }
`;
var Ellipsis = styled6.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
`;
var PaginationSizeSelector = ({ data, pageSize, setPageSize }) => {
  const { selectedItem, handleToggleSelect } = useSelect("SINGLE", data, {
    key: "value"
  });
  const handleClickMenu = (value) => {
    handleToggleSelect(value);
    setPageSize(value);
  };
  return /* @__PURE__ */ jsx(
    Dropdown_default,
    {
      option: "CLICK",
      width: "66px",
      trigger: /* @__PURE__ */ jsx(
        Dropdown_default.Button,
        {
          placeholder: String(pageSize),
          sizeVar: "S",
          value: selectedItem && /* @__PURE__ */ jsx(Text_default, { typography: "body1_400", color: "neutral400", children: selectedItem.label })
        }
      ),
      popper: /* @__PURE__ */ jsx(Dropdown_default.Content, { type: "FILL", children: data.map((item) => {
        const isSelected = item.value === pageSize;
        return /* @__PURE__ */ jsx(Menu_default, { isSelected, onClick: () => handleClickMenu(item.value), children: item.label }, item.value);
      }) })
    }
  );
};
var PaginationSizeSelector_default = PaginationSizeSelector;
var Pagination = (_a) => {
  var _b = _a, {
    currentPage,
    pageCount = 5,
    itemsTotalCount,
    pageSize,
    previousPage,
    nextPage,
    gotoPage,
    leftSource,
    rightSource,
    totalCount
  } = _b, rest = __objRest(_b, [
    "currentPage",
    "pageCount",
    "itemsTotalCount",
    "pageSize",
    "previousPage",
    "nextPage",
    "gotoPage",
    "leftSource",
    "rightSource",
    "totalCount"
  ]);
  const pageTotalCount = totalCount != null ? totalCount : Math.ceil(itemsTotalCount / Number(pageSize));
  const showLeftEllipsis = currentPage > pageCount - 1;
  const showRightEllipsis = currentPage < pageTotalCount && Math.ceil((currentPage + 1) / pageCount) < Math.ceil(pageTotalCount / pageCount);
  const canPreviousPage = currentPage > 0;
  const canNextPage = currentPage < pageTotalCount - 1;
  return /* @__PURE__ */ jsxs(PaginationWrapper, __spreadProps(__spreadValues({}, rest), { children: [
    leftSource ? leftSource : /* @__PURE__ */ jsx("div", {}),
    /* @__PURE__ */ jsxs(StyledPagination, { "data-shoplflow": "Pagination", children: [
      /* @__PURE__ */ jsx(IconButton_default, { sizeVar: "S", styleVar: "GHOST", disabled: !canPreviousPage, onClick: () => gotoPage(0), children: /* @__PURE__ */ jsx(Icon_default, { iconSource: FirstPageIcon, color: "neutral400", sizeVar: "S" }) }),
      /* @__PURE__ */ jsx(IconButton_default, { sizeVar: "S", styleVar: "GHOST", onClick: previousPage, disabled: !canPreviousPage, children: /* @__PURE__ */ jsx(Icon_default, { iconSource: LeftArrowIcon, color: "neutral400", sizeVar: "S" }) }),
      showLeftEllipsis && /* @__PURE__ */ jsx(Ellipsis, { children: /* @__PURE__ */ jsx(Text_default, { typography: "body2_700", children: "..." }) }),
      [...Array(pageTotalCount)].splice(0, pageCount).map(
        (_, idx) => idx + Math.floor(currentPage / pageCount) * pageCount < pageTotalCount && /* @__PURE__ */ jsx(
          PageItem,
          {
            isActive: currentPage === idx + Math.floor(currentPage / pageCount) * pageCount,
            onClick: () => gotoPage(idx + Math.floor(currentPage / pageCount) * pageCount),
            children: /* @__PURE__ */ jsx(Text_default, { typography: "body2_700", children: idx + 1 + Math.floor(currentPage / pageCount) * pageCount })
          },
          idx
        )
      ),
      showRightEllipsis && /* @__PURE__ */ jsx(Ellipsis, { children: /* @__PURE__ */ jsx(Text_default, { typography: "body2_700", children: "..." }) }),
      /* @__PURE__ */ jsx(IconButton_default, { sizeVar: "S", styleVar: "GHOST", onClick: nextPage, disabled: !canNextPage, children: /* @__PURE__ */ jsx(Icon_default, { iconSource: RightArrowIcon, color: "neutral400", sizeVar: "S" }) }),
      /* @__PURE__ */ jsx(IconButton_default, { sizeVar: "S", styleVar: "GHOST", disabled: !canNextPage, onClick: () => gotoPage(pageTotalCount - 1), children: /* @__PURE__ */ jsx(Icon_default, { iconSource: EndPageIcon, color: "neutral400", sizeVar: "S" }) })
    ] }),
    rightSource ? rightSource : /* @__PURE__ */ jsx("div", {})
  ] }));
};
Pagination.SizeSelector = PaginationSizeSelector_default;
var Pagination_default = Pagination;
var getLabelStyleByStatus = (selected, disabled) => {
  if (disabled) {
    return css`
      cursor: not-allowed;
      opacity: 0.5;
    `;
  }
  if (selected) {
    return css`
      cursor: default;
      background-color: ${colorTokens.neutral0};
    `;
  }
};
var getLabelStyleBySizeVar = (sizeVar) => {
  switch (sizeVar) {
    case "S": {
      return css`
        padding: 4px 8px;
      `;
    }
    case "M": {
      return css`
        padding: 8px;
      `;
    }
    default: {
      return;
    }
  }
};
var StyledToggleButton = styled6.div`
  display: flex;
  padding: ${spacingTokens.spacing04};
  align-items: center;
  background-color: ${colorTokens.neutral150};
  border-radius: ${borderRadiusTokens.borderRadius06};
`;
var StyledToggleInner = styled6.button`
  height: fit-content;
  width: fit-content;
  cursor: pointer;

  & input:checked + label {
    background-color: ${colorTokens.neutral0};
    cursor: default;
  }
`;
var StyledToggleInnerLabel = styled6.label`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${({ width }) => `${width}px`};
  padding: 0 12px;
  border-radius: 6px;
  background-color: transparent;
  ${({ disabled, selected }) => getLabelStyleByStatus(selected, Boolean(disabled))}
  ${({ sizeVar }) => getLabelStyleBySizeVar(sizeVar)}

  &:hover {
    ${({ disabled }) => !disabled && css`
        cursor: pointer;
        background-color: ${colorTokens.neutral400_5};
      `}
  }
`;
var StyledToggleInnerInput = styled6.input`
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  visibility: hidden;
`;
var ToggleButtonContext = createContext(null);
var useToggleButton = () => {
  const context = useContext(ToggleButtonContext);
  if (!context) {
    throw new Error("ToggleInnerButton \uCEF4\uD3EC\uB10C\uD2B8\uB294 ToggleButton \uB0B4\uBD80\uC5D0\uC11C \uC0AC\uC6A9\uD574\uC8FC\uC138\uC694");
  }
  return context;
};
var ToggleButton = (_a) => {
  var _b = _a, {
    fixedWidth,
    children,
    targetName,
    onChange,
    selectedValue,
    sizeVar = "S"
  } = _b, rest = __objRest(_b, [
    "fixedWidth",
    "children",
    "targetName",
    "onChange",
    "selectedValue",
    "sizeVar"
  ]);
  return /* @__PURE__ */ jsx(ToggleButtonContext.Provider, { value: { fixedWidth, targetName, onChange, selectedValue, sizeVar }, children: /* @__PURE__ */ jsx(StyledToggleButton, __spreadProps(__spreadValues({ "data-shoplflow": "ToggleButton" }, rest), { children })) });
};
var ToggleInnerRadio = forwardRef(
  (_a, ref) => {
    var _b = _a, { label, disabled, value, id } = _b, rest = __objRest(_b, ["label", "disabled", "value", "id"]);
    const { fixedWidth, onChange, targetName, selectedValue, sizeVar } = useToggleButton();
    let selected = false;
    if (selectedValue && selectedValue === value) {
      selected = true;
    }
    return /* @__PURE__ */ jsxs(StyledToggleInner, { disabled, type: "button", children: [
      /* @__PURE__ */ jsx(
        StyledToggleInnerInput,
        __spreadProps(__spreadValues({
          width: fixedWidth,
          disabled,
          selected,
          value,
          id,
          type: "radio",
          ref,
          name: targetName
        }, rest), {
          onChange
        })
      ),
      /* @__PURE__ */ jsx(
        StyledToggleInnerLabel,
        {
          htmlFor: id,
          width: fixedWidth,
          disabled,
          selected,
          sizeVar,
          children: /* @__PURE__ */ jsx(
            Text_default,
            {
              lineClamp: 1,
              color: selected ? "neutral700" : "neutral500",
              wordBreak: "break-all",
              typography: selected ? "body2_500" : "body2_400",
              children: label
            }
          )
        }
      )
    ] });
  }
);
ToggleButton.InnerRadio = ToggleInnerRadio;
var ToggleButton_default = ToggleButton;

// src/components/ToggleButton/ToggleButton.types.ts
var ToggleButtonSizeVariants = {
  S: "S",
  M: "M"
};
var SmallStyledDayDatepickerWrapper = styled6.div`
  display: flex;
  width: 280px;
  height: 100%;
  flex-direction: column;

  & .dayDatepickerArea .react-datepicker {
    width: 100%;
    height: 100%;
    border: none;
    margin: 0;
    padding: 16px;
    box-sizing: border-box;
    font-family: 'Pretendard', 'Pretendard JP', sans-serif !important;

    & .highlighted-sundays {
      color: ${colorTokens.red300};
    }

    &__month-text--selected {
      color: #fff;
    }

    &-popper {
      width: 432px;
      padding-top: 0;
    }

    &__month-container {
      width: 100%;
    }

    &__month {
      margin: 0;
    }

    &__header {
      border: none;
      background-color: transparent;
      padding: 0;
      font-size: 14px;
      font-style: normal;
      line-height: 18px;
    }

    &__month-wrapper {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      /* gap: 1.75rem; */
    }

    &__month-text {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      font-size: 16px;
      color: #333;
      font-weight: 400;

      :hover {
        background-color: ${colorTokens.primary100};
        color: ${colorTokens.primary300};
      }

      &--keyboard-selected {
        background-color: ${colorTokens.primary100};
        color: ${colorTokens.neutral700};
      }

      &--selected:not(.react-datepicker--keyboard-selected) {
        background-color: ${colorTokens.primary300};
        color: ${colorTokens.neutral0};
      }
    }

    &__week {
      width: 100%;
      display: flex;
      justify-content: space-between;

      &:first-of-type {
        margin-top: 0;
      }
    }

    &__day-names {
      width: 100%;
      height: 18px;
      margin: 8px 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &__day-name {
      color: ${colorTokens.neutral400};
      width: 32px;
      margin: 0;
      font-size: 13px;
      font-weight: 500;
      line-height: 1rem;

      :last-of-type {
        margin: 0;
      }
    }

    &__day {
      width: 32px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 32px;
      color: ${colorTokens.neutral700};
      border-radius: 50%;
      font-size: 14px;
      font-weight: 500;
      margin: 0px;

      &--keyboard-selected {
        background-color: transparent;
      }

      &--outside-month {
        color: ${colorTokens.neutral400};
      }

      &--today {
        color: ${colorTokens.primary300};
        font-weight: ${fontWeightTokens.fontWeightRegular};
      }

      &--in-selecting-range:not(
          .react-datepicker__day--in-range,
          .react-datepicker__month-text--in-range,
          .react-datepicker__quarter-text--in-range,
          .react-datepicker__year-text--in-range,
          .react-datepicker__day--selecting-range-start
        ) {
        background-color: ${colorTokens.primary100};
      }

      &--in-range {
        background-color: ${colorTokens.primary300};
        color: ${colorTokens.neutral0};
        position: relative;

        &:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
          border-radius: 0;
          background-color: ${colorTokens.primary100};
          color: ${colorTokens.primary300};
        }

        &:not(.react-datepicker__day--range-end):after {
          width: 4px;
          height: 100%;
          background-color: ${colorTokens.primary100};
          position: absolute;
          content: '';
          right: -4px;
          top: 0;
          z-index: 1;
        }

        &.react-datepicker__day--range-start {
          width: 32px;
          height: 32px;
          background-color: ${colorTokens.primary100};
          margin-right: 0;
          box-sizing: border-box;
          border: unset;
          border-radius: 50% 0 0 50%;
        }

        &.react-datepicker__day--range-end {
          width: 32px;
          height: 32px;
          background-color: ${colorTokens.primary100};
          box-sizing: border-box;
          border: unset;
          border-radius: 0 50% 50% 0;
        }
        &.react-datepicker__day--range-end.react-datepicker__day--range-start {
          width: 32px;
          height: 32px;
          background-color: ${colorTokens.primary100};
          box-sizing: border-box;
          border: unset;
          border-radius: 50%;
        }
        &.react-datepicker__day--range-start .each-day {
          width: 32px;
          height: 32px;
          background-color: ${colorTokens.primary300};
          border-radius: 100%;
        }

        &.react-datepicker__day--range-end .each-day {
          width: 32px;
          height: 32px;
          background-color: ${colorTokens.primary300};
          border-radius: 100%;
        }
      }

      &--selected {
        color: ${colorTokens.neutral0};
        background-color: ${colorTokens.primary300};
      }

      &--highlighted {
        color: ${colorTokens.neutral0};
        background-color: ${colorTokens.primary300};
      }

      &--disabled {
        cursor: not-allowed;
        opacity: 0.3;
        color: ${colorTokens.neutral700};

        &.react-datepicker__day--keyboard-selected {
          background-color: ${colorTokens.neutral200};
        }
        &.react-datepicker__day--excluded {
          color: ${colorTokens.neutral0};
        }
      }

      &:not(&--disabled):not(&--selected):not(&--highlighted):not(&--range-end):hover {
        color: ${colorTokens.primary300};
        background-color: ${colorTokens.primary100};
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &__year {
      &-wrapper {
        justify-content: center;
      }
    }
  }
`;
var StyledDayDatepicker = styled6.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;

  & .dayDatepickerArea .react-datepicker {
    width: 100%;
    height: 100%;
    border: none;
    margin: 0;
    padding: 16px 30px 16px;
    box-sizing: border-box;
    font-family: 'Pretendard', 'Pretendard JP', sans-serif !important;

    & .highlighted-sundays {
      color: ${colorTokens.red300};
    }

    &__month-text--selected {
      color: #fff;
    }

    &-popper {
      width: 432px;
      padding-top: 0;
    }

    &__month-container {
      width: 100%;
    }

    &__month {
      margin: 12px 0 0;
    }

    &__header {
      border: none;
      background-color: transparent;
      padding: 0;
    }

    &__month-wrapper {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      /* gap: 1.75rem; */
    }

    &__month-text {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      font-size: 16px;
      color: #333;

      :hover {
        background-color: ${colorTokens.primary100};
        color: ${colorTokens.primary300};
      }

      &--keyboard-selected {
        background-color: ${colorTokens.primary100};
        color: ${colorTokens.neutral700};
      }

      &--selected:not(.react-datepicker--keyboard-selected) {
        background-color: ${colorTokens.primary300};
        color: ${colorTokens.neutral0};
      }
    }

    &__week {
      margin-top: 8px;

      &:first-of-type {
        margin-top: 0;
      }
    }

    &__day-names {
      height: 18px;
      margin: 12px 0 0;
    }

    &__day-name {
      width: 40px;
      margin: 0 10px 0 0;
      color: ${colorTokens.navy300};
      font-size: 13px;
      font-weight: 500;
      line-height: 1rem;

      :last-of-type {
        margin: 0;
      }
    }

    &__day {
      width: 40px;
      height: 40px;
      line-height: 40px;
      margin: 0 10px 0 0;
      color: ${colorTokens.neutral700};
      border-radius: 50%;
      font-size: 14px;
      font-weight: 500;

      &--keyboard-selected {
        background-color: transparent;
      }

      &--outside-month {
        color: ${colorTokens.neutral400};
      }

      &--today {
        color: ${colorTokens.primary300};
        font-weight: ${fontWeightTokens.fontWeightRegular};
      }

      &--in-selecting-range:not(
          .react-datepicker__day--in-range,
          .react-datepicker__month-text--in-range,
          .react-datepicker__quarter-text--in-range,
          .react-datepicker__year-text--in-range,
          .react-datepicker__day--selecting-range-start
        ) {
        background-color: ${colorTokens.primary100};
      }

      &--in-range {
        background-color: ${colorTokens.primary300};
        color: ${colorTokens.neutral0};
        position: relative;

        &:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
          border-radius: 0;
          background-color: ${colorTokens.primary100};
          color: ${colorTokens.primary300};
        }

        &:not(.react-datepicker__day--range-end):not(.react-datepicker__day--range-start):after {
          width: 10px;
          height: 100%;
          background-color: ${colorTokens.primary100};
          position: absolute;
          content: '';
          right: -10px;
          top: 0;
          z-index: 1;
        }

        &.react-datepicker__day--range-start {
          width: 50px;
          height: 40px;
          background-color: ${colorTokens.primary100};
          margin-right: 0;
          padding-right: 10px;
          box-sizing: border-box;
          border: unset;
          border-radius: 50% 0 0 50%;
        }

        &.react-datepicker__day--range-end {
          width: 40px;
          height: 40px;
          background-color: ${colorTokens.primary100};
          box-sizing: border-box;
          border: unset;
          border-radius: 0 50% 50% 0;
        }
        &.react-datepicker__day--range-end.react-datepicker__day--range-start {
          width: 40px;
          height: 40px;
          background-color: ${colorTokens.primary100};
          box-sizing: border-box;
          border: unset;
          border-radius: 50%;
          margin-right: 10px;
        }
        &.react-datepicker__day--range-start .each-day {
          width: 40px;
          height: 40px;
          background-color: ${colorTokens.primary300};
          border-radius: 100%;
        }

        &.react-datepicker__day--range-end .each-day {
          width: 40px;
          height: 40px;
          background-color: ${colorTokens.primary300};
          border-radius: 100%;
        }
      }

      &--selected {
        color: ${colorTokens.neutral0};
        background-color: ${colorTokens.primary300};
      }

      &--highlighted {
        color: ${colorTokens.neutral0};
        background-color: ${colorTokens.primary300};
      }

      &--disabled {
        cursor: not-allowed;
        opacity: 0.3;
        color: ${colorTokens.neutral700};

        &.react-datepicker__day--keyboard-selected {
          background-color: ${colorTokens.neutral200};
        }
        &.react-datepicker__day--excluded {
          color: ${colorTokens.neutral0};
        }
      }

      &:not(&--disabled):not(&--selected):not(&--highlighted):not(&--range-end):hover {
        color: ${colorTokens.primary300};
        background-color: ${colorTokens.primary100};
      }
    }

    &__year {
      &-wrapper {
        justify-content: center;
      }
    }
  }
`;
var Header = styled6.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 32px;
  gap: 8px;
`;
var Month = styled6.p`
  font-size: 18px;
  color: ${colorTokens.neutral700};
  cursor: pointer;
`;
var DatePickerWrapper = styled6.div`
  position: absolute;
  z-index: 10;
  top: 36px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0px 10px 30px 0px rgba(51, 51, 51, 0.2);
  height: fit-content;
  padding: 16px 24px 24px 24px;
  background-color: ${colorTokens.neutral0};

  & .react-datepicker {
    padding: 0px !important;

    &__header--custom {
      margin-bottom: 16px;
    }

    &__month-wrapper {
      column-gap: 8px;
      margin-top: 8px;
    }

    &__month-text--today {
      font-weight: ${fontWeightTokens.fontWeightRegular};
    }
  }
`;
var Container5 = styled6.div`
  border-radius: 4px;
  background-color: ${colorTokens.neutral0};
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.12);
  padding: 4px;
  z-index: 10;
  position: relative;
  top: 0px;
  left: 0px;
  width: 60px;

  & .simplebar-placeholder {
    height: 0px !important;
  }
`;
var OptionList = styled6.ul`
  height: fit-content;

  ${({ maxHeight }) => {
  if (maxHeight) {
    return `
                max-height: ${maxHeight};
                overflow: auto;
                overflow-y: scroll;        

                -ms-overflow-style: none; /* IE and Edge */
                scrollbar-width: none; /* Firefox */

                &::-webkit-scrollbar {
                    display: none; /* Chrome, Safari, Opera*/
                }
            `;
  }
}}
`;
var OptionListItem = styled6.li`
  padding: 7px 8px;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  cursor: pointer;
  border-radius: 4px;
  background-color: ${({ isActive }) => isActive && colorTokens.primary300};
  color: ${({ isActive }) => isActive && colorTokens.neutral0};

  &:hover {
    background-color: ${({ isActive }) => !isActive && colorTokens.neutral100};
  }
`;
var YearSelect = ({ optionList, className, parentClassName, activeValue, maxHeight, onClick }) => {
  var _a;
  const optionListRef = useRef([]);
  const parentRef = useRef(null);
  const [isAllRefMounted, setIsAllRefMounted] = useState(false);
  const [isOpened, setIsOpened] = useOutsideClick({
    selector: `.${parentClassName}` || ""
  });
  useEffect(() => {
    setIsOpened(isOpened);
  }, []);
  const height = Math.min(((_a = optionList == null ? void 0 : optionList.length) != null ? _a : 0) * 32, Number(parseInt(maxHeight || "0")));
  useEffect(() => {
    var _a2, _b, _c, _d, _e, _f;
    if (!isAllRefMounted || !activeValue || !maxHeight) {
      return;
    }
    const selectedOptionIndex = optionList.findIndex((option) => (option == null ? void 0 : option.value) === activeValue);
    const heightPerOption = (_b = (_a2 = optionListRef.current[selectedOptionIndex]) == null ? void 0 : _a2.offsetHeight) != null ? _b : 0;
    const parentHeight = (_e = (_d = (_c = optionListRef.current[selectedOptionIndex]) == null ? void 0 : _c.closest("ul")) == null ? void 0 : _d.clientHeight) != null ? _e : 0;
    if (heightPerOption * (selectedOptionIndex + 1) >= parentHeight) {
      (_f = parentRef.current) == null ? void 0 : _f.scrollTo({ top: heightPerOption * selectedOptionIndex });
    }
  }, [isAllRefMounted, activeValue, maxHeight]);
  return /* @__PURE__ */ jsx(Container5, { className: `${parentClassName} ${className}`, children: /* @__PURE__ */ jsx(OptionList, { ref: parentRef, maxHeight, style: { height }, className, children: /* @__PURE__ */ jsx(
    SimpleBarReact,
    {
      style: {
        maxHeight,
        height
      },
      placeholder: void 0,
      className,
      children: optionList == null ? void 0 : optionList.map((option, index) => /* @__PURE__ */ jsx(
        OptionListItem,
        {
          onClick: (event) => {
            event.stopPropagation();
            onClick(option);
          },
          isActive: activeValue === option.value,
          ref: (el) => {
            optionListRef.current[index] = el;
            index + 1 === optionList.length && setIsAllRefMounted(true);
          },
          className,
          children: option.label
        },
        option.value
      ))
    }
  ) }) });
};
var YearSelect_default = YearSelect;
var YearStepper = ({
  date,
  decreaseYear,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
  increaseYear,
  changeYear,
  minDate,
  maxDate,
  className
}) => {
  const [isOpen, setIsOpen] = useOutsideClick({
    selector: ".react-datepicker-year-stepper"
  });
  const startYear = minDate ? minDate.getFullYear() : 2e3;
  const endYear = maxDate ? maxDate.getFullYear() : 2100;
  const OptionList2 = useMemo(
    () => Array.from({ length: endYear - startYear + 1 }).fill(0).map((_, index) => ({ value: startYear + index, label: `${startYear + index}` })),
    [startYear, endYear]
  );
  return /* @__PURE__ */ jsxs(Header, { className: `calendarHeader ${className}`, children: [
    /* @__PURE__ */ jsx(
      IconButton_default,
      {
        styleVar: "GHOST",
        sizeVar: "S",
        onClick: decreaseYear,
        disabled: prevYearButtonDisabled || date.getFullYear() === startYear,
        children: /* @__PURE__ */ jsx(Icon_default, { iconSource: LeftArrowIcon, sizeVar: "XS", color: prevYearButtonDisabled ? "neutral200" : "neutral700" })
      }
    ),
    /* @__PURE__ */ jsxs(Popper_default, { placement: "bottom", middlewares: [flip(), shift({ padding: 5 })], children: [
      /* @__PURE__ */ jsx(Popper_default.Trigger, { isOpen, children: /* @__PURE__ */ jsx(
        Month,
        {
          className: `react-datepicker-year-stepper ${className}`,
          onClick: (event) => {
            event.stopPropagation();
            setIsOpen((prev) => !prev);
          },
          children: /* @__PURE__ */ jsx(Text_default, { typography: "title1_700", children: `${date.getFullYear()}` })
        }
      ) }),
      /* @__PURE__ */ jsx(Popper_default.Portal, { children: /* @__PURE__ */ jsx(
        YearSelect_default,
        {
          className: `react-datepicker-year-stepper ${className}`,
          optionList: OptionList2,
          onClick: ({ value }) => {
            changeYear(value);
            setIsOpen(false);
          },
          parentClassName: `react-datepicker-year-stepper ${className}`,
          maxHeight: `200px`,
          activeValue: date.getFullYear()
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx(
      IconButton_default,
      {
        styleVar: "GHOST",
        sizeVar: "S",
        onClick: increaseYear,
        disabled: nextYearButtonDisabled || date.getFullYear() === endYear,
        children: /* @__PURE__ */ jsx(Icon_default, { iconSource: RightArrowIcon, sizeVar: "XS", color: nextYearButtonDisabled ? "neutral200" : "neutral700" })
      }
    )
  ] });
};
var YearStepper_default = YearStepper;
var MonthStepper = ({
  date,
  monthDate,
  decreaseMonth,
  increaseMonth,
  changeYear,
  changeMonth,
  minDate,
  maxDate,
  locale,
  sizeVar,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  className
}) => {
  const [isOpen, setIsOpen] = useOutsideClick({
    selector: ".react-datepicker__header"
  });
  return /* @__PURE__ */ jsxs(Header, { className: `calendarHeader ${className}`, children: [
    /* @__PURE__ */ jsx(IconButton_default, { styleVar: "GHOST", sizeVar: "S", onClick: decreaseMonth, disabled: prevMonthButtonDisabled, children: /* @__PURE__ */ jsx(Icon_default, { iconSource: LeftArrowIcon, sizeVar: "XS", color: prevMonthButtonDisabled ? "neutral200" : "neutral700" }) }),
    /* @__PURE__ */ jsx(
      Month,
      {
        className: `react-datepicker__header ${className}`,
        onClick: () => {
          setIsOpen((prev) => !prev);
        },
        children: /* @__PURE__ */ jsx(Text_default, { typography: sizeVar === "M" ? "title1_700" : "body1_700", children: `${date.getFullYear()}.${monthDate.getMonth() + 1}` })
      }
    ),
    isOpen && /* @__PURE__ */ jsx(DatePickerWrapper, { children: /* @__PURE__ */ jsx("div", { className: `datepicker-header-wrapper ${className}`, children: /* @__PURE__ */ jsx(
      DatePicker2,
      {
        className: `datepicker-custom-month ${className}`,
        onChange: (date2) => {
          if (!date2) {
            return;
          }
          changeYear && changeYear(date2.getFullYear());
          changeMonth && changeMonth(date2.getMonth());
          setIsOpen(false);
        },
        inline: true,
        selectsEnd: true,
        dateFormat: "mm",
        selected: date,
        minDate,
        maxDate,
        locale: locale != null ? locale : ko,
        showMonthYearPicker: true,
        renderCustomHeader: (props) => /* @__PURE__ */ jsx(YearStepper_default, __spreadProps(__spreadValues({}, props), { minDate, maxDate, className })),
        showFourColumnMonthYearPicker: true
      }
    ) }) }),
    /* @__PURE__ */ jsx(IconButton_default, { styleVar: "GHOST", sizeVar: "S", onClick: increaseMonth, disabled: nextMonthButtonDisabled, children: /* @__PURE__ */ jsx(Icon_default, { iconSource: RightArrowIcon, sizeVar: "XS", color: nextMonthButtonDisabled ? "neutral200" : "neutral700" }) })
  ] });
};
var MonthStepper_default = MonthStepper;
var DayDatepicker = (_a) => {
  var _b = _a, {
    sizeVar,
    children,
    minDate,
    maxDate,
    calendarType,
    locale,
    fixedHeight = true,
    className
  } = _b, rest = __objRest(_b, [
    "sizeVar",
    "children",
    "minDate",
    "maxDate",
    "calendarType",
    "locale",
    "fixedHeight",
    "className"
  ]);
  const Wrapper2 = sizeVar === "S" ? SmallStyledDayDatepickerWrapper : StyledDayDatepicker;
  if (calendarType.type === "range") {
    return /* @__PURE__ */ jsx(Wrapper2, { "data-shoplflow": "DayDatepicker", className, children: /* @__PURE__ */ jsx("div", { className: `${"dayDatepickerArea"}${className ? ` ${className}` : ""}`, children: /* @__PURE__ */ jsx(
      DatePicker2,
      __spreadProps(__spreadValues({
        inline: true,
        renderCustomHeader: (props) => /* @__PURE__ */ jsx(
          MonthStepper_default,
          __spreadProps(__spreadValues({
            sizeVar: sizeVar || "M"
          }, props), {
            minDate,
            maxDate,
            locale,
            className
          })
        ),
        renderDayContents: (dayOfMonth) => {
          return /* @__PURE__ */ jsx("div", { className: "each-day", children: dayOfMonth });
        },
        className
      }, rest), {
        minDate,
        maxDate,
        selectsRange: true,
        selectsMultiple: void 0,
        locale,
        onChange: calendarType.handleDayRangeChange,
        fixedHeight,
        children
      })
    ) }) });
  }
  if (calendarType.type === "multiple") {
    return /* @__PURE__ */ jsx(Wrapper2, { "data-shoplflow": "DayDatepicker", className, children: /* @__PURE__ */ jsx("div", { className: `${"dayDatepickerArea"}${className ? ` ${className}` : ""}`, children: /* @__PURE__ */ jsx(
      DatePicker2,
      __spreadProps(__spreadValues({
        inline: true,
        renderCustomHeader: (props) => /* @__PURE__ */ jsx(
          MonthStepper_default,
          __spreadProps(__spreadValues({
            sizeVar: sizeVar || "M"
          }, props), {
            minDate,
            maxDate,
            locale,
            className
          })
        ),
        renderDayContents: (dayOfMonth) => {
          return /* @__PURE__ */ jsx("div", { className: "each-day", children: dayOfMonth });
        }
      }, rest), {
        minDate,
        maxDate,
        locale,
        selectsMultiple: true,
        onChange: calendarType.handleMutlipleDaysChange,
        fixedHeight,
        children
      })
    ) }) });
  }
  return /* @__PURE__ */ jsx(Wrapper2, { "data-shoplflow": "DayDatepicker", children: /* @__PURE__ */ jsx("div", { className: `${"dayDatepickerArea"}${className ? ` ${className}` : ""}`, children: /* @__PURE__ */ jsx(
    DatePicker2,
    __spreadProps(__spreadValues({
      inline: true,
      renderCustomHeader: (props) => /* @__PURE__ */ jsx(
        MonthStepper_default,
        __spreadProps(__spreadValues({
          sizeVar: sizeVar || "M"
        }, props), {
          minDate,
          maxDate,
          locale,
          className
        })
      ),
      renderDayContents: (dayOfMonth) => {
        return /* @__PURE__ */ jsx("div", { className: "each-day", children: dayOfMonth });
      }
    }, rest), {
      minDate,
      maxDate,
      locale,
      onChange: calendarType.handleDayChange,
      fixedHeight,
      children
    })
  ) }) });
};
var DayDatepicker_default = DayDatepicker;

// src/components/Datepickers/DayDatepicker/DayDatepicker.types.ts
var DayDatepickerSizeVariants = {
  S: "S",
  M: "M"
};
var getEachDateStyle = (props) => {
  const { inRange, isStart, isEnd, disabled } = props;
  if (isStart || isEnd) {
    return css`
      background-color: ${colorTokens.primary300};
      color: ${colorTokens.neutral0};
    `;
  }
  if (inRange) {
    return css`
      background-color: ${colorTokens.primary100};
      color: ${colorTokens.neutral700};
    `;
  }
  if (disabled) {
    return css`
      color: ${colorTokens.neutral400};
      cursor: not-allowed;
    `;
  }
  return css`
    &:hover {
      background-color: ${colorTokens.primary100};
    }
  `;
};
var getEachMonthAreaStyle = (props) => {
  const { inRange, isStart, isEnd, isReady, disabled } = props;
  if (isStart && isEnd) {
    return;
  }
  if (isStart && isReady && !isEnd) {
    return css`
      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        width: 48px;
        background: ${colorTokens.primary100};
      }
    `;
  }
  if (isEnd && !isStart) {
    return css`
      &::after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 48px;
        background: ${colorTokens.primary100};
      }
    `;
  }
  if (inRange) {
    return css`
      background-color: ${colorTokens.primary100};
      color: ${colorTokens.neutral700};
    `;
  }
  if (disabled) {
    return css`
      cursor: not-allowed;
    `;
  }
};
var MonthContainer = styled6.div`
  display: flex;
  flex-direction: column;
  width: 400px;
  max-width: 400px;
  gap: 16px;
  padding: 16px 24px 24px;
`;
var MonthArea = styled6.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-row-gap: 16px;
`;
var EachMonthArea = styled6.div`
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  ${(props) => getEachMonthAreaStyle(props)}
`;
var EachMonthDate = styled6.div`
  width: 48px;
  height: 48px;
  text-align: center;
  font-size: 14px;
  line-height: 48px;
  padding: 0;
  border-radius: 50%;
  cursor: pointer;
  position: absolute;
  z-index: 10;

  ${(props) => getEachDateStyle(props)}
`;
var MonthDatepicker = ({
  handleMonthClick,
  initStartDate,
  initEndDate,
  minDate,
  maxDate,
  onlySingleMonth
}) => {
  const [currentDate, setCurrentDate] = useState(initStartDate || /* @__PURE__ */ new Date());
  const [selectedStartMonthAndYear, setSelectedStartMonthAndYear] = useState(
    initStartDate ? [initStartDate.getMonth() + 1, initStartDate.getFullYear()] : null
  );
  const [selectedEndMonthAndYear, setSelectedEndMonthAndYear] = useState(
    initEndDate ? [initEndDate.getMonth() + 1, initEndDate.getFullYear()] : null
  );
  const Months = useMemo(() => {
    return Array.from({ length: 12 }).map((_, index) => index + 1);
  }, []);
  const clickMonth = (month, year) => {
    if (onlySingleMonth) {
      setSelectedStartMonthAndYear([month, year]);
      handleMonthClick({
        startDate: startOfMonth(new Date(year, month - 1)),
        endDate: endOfMonth(new Date(year, month - 1)),
        selectedMonthRange: 1
      });
      return;
    }
    if (!selectedStartMonthAndYear || selectedStartMonthAndYear && selectedEndMonthAndYear) {
      const startDate = startOfMonth(new Date(year, month - 1));
      const endDate = endOfMonth(new Date(year, month - 1));
      setSelectedStartMonthAndYear([month, year]);
      setSelectedEndMonthAndYear(null);
      handleMonthClick({
        startDate,
        endDate,
        // 현재 달 까지 포함
        selectedMonthRange: differenceInCalendarMonths(endDate, startDate) + 1
      });
      return;
    }
    if (selectedStartMonthAndYear && !selectedEndMonthAndYear) {
      const [selectedMonth, selectedYear] = selectedStartMonthAndYear;
      if (selectedYear > year || selectedYear === year && selectedMonth > month) {
        const startDate2 = startOfMonth(new Date(year, month - 1));
        const endDate2 = endOfMonth(new Date(selectedYear, selectedMonth - 1));
        setSelectedStartMonthAndYear([month, year]);
        setSelectedEndMonthAndYear([selectedMonth, selectedYear]);
        handleMonthClick({
          startDate: startDate2,
          endDate: endDate2,
          // 현재 달 까지 포함
          selectedMonthRange: differenceInCalendarMonths(endDate2, startDate2) + 1
        });
        return;
      }
      if (selectedMonth !== month || selectedYear !== year) {
        setSelectedEndMonthAndYear([month, year]);
      }
      const startDate = startOfMonth(new Date(selectedYear, selectedMonth - 1));
      const endDate = endOfMonth(new Date(year, month - 1));
      handleMonthClick({
        startDate,
        endDate,
        // 현재 달까지 포함
        selectedMonthRange: differenceInCalendarMonths(endDate, startDate) + 1
      });
    }
  };
  return /* @__PURE__ */ jsxs(MonthContainer, { "data-shoplflow": "MonthDatepicker", children: [
    /* @__PURE__ */ jsx(
      YearStepper_default,
      {
        date: currentDate,
        decreaseYear: () => {
          setCurrentDate(new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), currentDate.getDate()));
        },
        minDate,
        maxDate,
        prevYearButtonDisabled: minDate ? minDate.getFullYear() === currentDate.getFullYear() : false,
        nextYearButtonDisabled: maxDate ? maxDate.getFullYear() === currentDate.getFullYear() : false,
        increaseYear: () => {
          setCurrentDate(new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDate()));
        },
        changeYear: (year) => {
          setCurrentDate(new Date(year, currentDate.getMonth(), currentDate.getDate()));
        }
      }
    ),
    /* @__PURE__ */ jsx(MonthArea, { children: Months.map((month) => {
      const currentYear = currentDate.getFullYear();
      const isStart = currentYear === (selectedStartMonthAndYear == null ? void 0 : selectedStartMonthAndYear[1]) && month === (selectedStartMonthAndYear == null ? void 0 : selectedStartMonthAndYear[0]);
      const isEnd = (selectedEndMonthAndYear == null ? void 0 : selectedEndMonthAndYear[1]) === currentYear && (selectedEndMonthAndYear == null ? void 0 : selectedEndMonthAndYear[0]) === month;
      const isReady = isStart && Boolean(selectedEndMonthAndYear);
      let inRange = false;
      let disabled = false;
      if (minDate) {
        const minMonth = minDate.getMonth() + 1;
        const minYear = minDate.getFullYear();
        if (currentYear < minYear) {
          disabled = true;
        }
        if (currentYear === minYear) {
          if (month <= minMonth) {
            disabled = true;
          }
        }
      }
      if (maxDate) {
        const maxMonth = maxDate.getMonth() + 1;
        const maxYear = maxDate.getFullYear();
        if (currentYear > maxYear) {
          disabled = true;
        }
        if (currentYear === maxYear) {
          if (month >= maxMonth) {
            disabled = true;
          }
        }
      }
      if (selectedStartMonthAndYear && selectedEndMonthAndYear) {
        const [startMonth, startYear] = selectedStartMonthAndYear;
        const [endMonth, endYear] = selectedEndMonthAndYear;
        if (currentYear > startYear && currentYear < endYear) {
          inRange = true;
        }
        if (currentYear === startYear && currentYear === endYear) {
          if (month >= startMonth && month <= endMonth) {
            inRange = true;
          }
        }
        if (currentYear === startYear && currentYear !== endYear) {
          if (month >= startMonth) {
            inRange = true;
          }
        }
        if (currentYear === endYear && currentYear !== startYear) {
          if (month <= endMonth) {
            inRange = true;
          }
        }
      }
      return /* @__PURE__ */ jsx(
        EachMonthArea,
        {
          inRange,
          isStart,
          isReady,
          isEnd,
          disabled,
          onClick: () => {
            if (disabled) {
              return;
            }
            clickMonth(month, currentDate.getFullYear());
          },
          children: /* @__PURE__ */ jsx(EachMonthDate, { inRange, isStart, isEnd, disabled, children: month })
        },
        month
      );
    }) })
  ] });
};
var MonthDatepicker_default = MonthDatepicker;
var getEachDateStyle2 = (props) => {
  const { isSelected, disabled } = props;
  if (isSelected) {
    return css`
      background-color: ${colorTokens.primary300};
      color: ${colorTokens.neutral0};
    `;
  }
  if (disabled) {
    return css`
      color: ${colorTokens.neutral400};
      cursor: not-allowed;
    `;
  }
  return css`
    &:hover {
      background-color: ${colorTokens.primary100};
    }
  `;
};
var getEachYearAreaStyle = (props) => {
  const { disabled } = props;
  if (disabled) {
    return css`
      cursor: not-allowed;
    `;
  }
};
var YearContainer = styled6.div`
  display: flex;
  flex-direction: column;
  width: 400px;
  max-width: 400px;
  gap: 16px;
  padding: 16px 24px 24px;
`;
var YearArea = styled6.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-row-gap: 16px;
`;
var EachYearArea = styled6.div`
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  user-select: none;

  ${(props) => getEachYearAreaStyle(props)}
`;
var EachYearDate = styled6.div`
  width: 48px;
  height: 48px;
  text-align: center;
  font-size: 14px;
  line-height: 48px;
  padding: 0;
  border-radius: 50%;
  cursor: pointer;
  position: absolute;
  z-index: 10;

  user-select: none;

  ${(props) => getEachDateStyle2(props)}
`;
var AnnualDatepicker = ({
  startYear = 2e3,
  endYear = 2100,
  currentYear,
  handleYearClick,
  disabledYears
}) => {
  const [selectedYear, setSelectedYear] = useState(currentYear || (/* @__PURE__ */ new Date()).getFullYear());
  const Years = Array.from({ length: endYear - startYear + 1 }).map((_, index) => startYear + index);
  const clickYear = (year) => {
    setSelectedYear(year);
    handleYearClick(year);
  };
  return /* @__PURE__ */ jsx(YearContainer, { "data-shoplflow": "AnnualDatepicker", children: /* @__PURE__ */ jsx(YearArea, { children: Years.map((year) => {
    const disabled = disabledYears == null ? void 0 : disabledYears.includes(year);
    return /* @__PURE__ */ jsx(
      EachYearArea,
      {
        disabled,
        isSelected: selectedYear === year,
        "aria-disabled": disabled,
        onClick: () => {
          if (disabled) {
            return;
          }
          clickYear(year);
        },
        children: /* @__PURE__ */ jsx(EachYearDate, { "aria-disabled": disabled, disabled, isSelected: selectedYear === year, children: year })
      },
      year
    );
  }) }) });
};
var AnnualDatepicker_default = AnnualDatepicker;
var getEachDateStyle3 = (props) => {
  const { inRange, isStart, isEnd, disabled } = props;
  if (isStart || isEnd) {
    return css`
      background-color: ${colorTokens.primary300};
      color: ${colorTokens.neutral0};
    `;
  }
  if (inRange) {
    return css`
      background-color: ${colorTokens.primary100};
      color: ${colorTokens.neutral700};
    `;
  }
  if (disabled) {
    return css`
      color: ${colorTokens.neutral400};
      cursor: not-allowed;
    `;
  }
  return css`
    &:hover {
      background-color: ${colorTokens.primary100};
    }
  `;
};
var getEachWeekAreaStyle = (props) => {
  const { inRange, isStart, isEnd, isReady, disabled } = props;
  if (isStart && isEnd) {
    return;
  }
  if (isStart && isReady) {
    return css`
      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        width: 24px;
        background: ${colorTokens.primary100};
      }
    `;
  }
  if (isEnd && !isStart) {
    return css`
      &::after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 24px;
        background: ${colorTokens.primary100};
      }
    `;
  }
  if (inRange) {
    return css`
      background-color: ${colorTokens.primary100};
      color: ${colorTokens.neutral700};
    `;
  }
  if (disabled) {
    return css`
      cursor: not-allowed;
    `;
  }
};
var WeekContainer = styled6.div`
  display: flex;
  flex-direction: column;
  width: 400px;
  max-width: 400px;
  gap: 16px;
  padding: 16px 24px 24px;
`;
var WeekArea = styled6.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-row-gap: 8px;
`;
var EachWeekArea = styled6.div`
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  ${(props) => getEachWeekAreaStyle(props)}
`;
var EachWeekDate = styled6.div`
  width: 48px;
  height: 48px;
  text-align: center;
  font-size: 14px;
  line-height: 48px;
  padding: 0;
  border-radius: 50%;
  cursor: pointer;
  position: absolute;
  z-index: 10;

  ${(props) => getEachDateStyle3(props)}
`;
function getWeeksInYear(year) {
  return getISOWeeksInYear(new Date(year, 5, 5));
}
var getStartOfISOWeek = (week, year) => {
  const januaryFourth = new Date(year, 0, 4);
  const firstWeekStart = startOfISOWeek(januaryFourth);
  const startOfWeek = addWeeks(firstWeekStart, week - 1);
  return startOfWeek;
};
var getEndOfISOWeek = (week, year) => {
  const januaryFourth = new Date(year, 0, 4);
  const firstWeekStart = startOfISOWeek(januaryFourth);
  const startOfWeek = addWeeks(firstWeekStart, week - 1);
  const endOfWeek = endOfISOWeek(startOfWeek);
  return endOfWeek;
};
var WeekDatepicker = ({
  handleWeekClick,
  initStartDate,
  initEndDate,
  minDate,
  maxDate,
  onlySingleWeek
}) => {
  const year = (initStartDate == null ? void 0 : initStartDate.getFullYear()) || (/* @__PURE__ */ new Date()).getFullYear();
  const [currentDate, setCurrentDate] = useState(new Date(year, 5, 5));
  const [selectedStartWeekAndYear, setSelectedStartWeekAndYear] = useState(
    initStartDate ? [getISOWeek(initStartDate || /* @__PURE__ */ new Date()), getISOWeekYear(initStartDate || /* @__PURE__ */ new Date())] : null
  );
  const [selectedEndWeekAndYear, setSelectedEndWeekAndYear] = useState(
    initEndDate ? [getISOWeek(initEndDate || /* @__PURE__ */ new Date()), getISOWeekYear(initEndDate || /* @__PURE__ */ new Date())] : null
  );
  const selectedYear = currentDate.getFullYear();
  const Years = useMemo(() => {
    return Array.from({ length: getWeeksInYear(selectedYear) }).map((_, index) => {
      return String(index + 1).padStart(2, "0");
    });
  }, [selectedYear]);
  const clickWeek = (week, year2) => {
    if (onlySingleWeek || !selectedStartWeekAndYear || selectedStartWeekAndYear && selectedEndWeekAndYear) {
      setSelectedStartWeekAndYear([week, year2]);
      setSelectedEndWeekAndYear(null);
      handleWeekClick({
        startYear: year2,
        startWeek: week,
        startDate: getStartOfISOWeek(week, year2),
        endYear: year2,
        endWeek: week,
        endDate: getEndOfISOWeek(week, year2),
        selectedWeeksRange: 1
      });
      return;
    }
    if (selectedStartWeekAndYear && !selectedEndWeekAndYear) {
      const [selectedWeek, selectedYear2] = selectedStartWeekAndYear;
      if (selectedYear2 > year2 || selectedYear2 === year2 && selectedWeek > week) {
        const startDate2 = getStartOfISOWeek(week, year2);
        const endDate2 = getEndOfISOWeek(selectedWeek, selectedYear2);
        setSelectedStartWeekAndYear([week, year2]);
        setSelectedEndWeekAndYear([selectedWeek, selectedYear2]);
        handleWeekClick({
          startYear: year2,
          startWeek: week,
          startDate: startDate2,
          endYear: selectedYear2,
          endWeek: selectedWeek,
          endDate: endDate2,
          // 현재 주까지 포함
          selectedWeeksRange: differenceInCalendarISOWeeks(endDate2, startDate2) + 1
        });
        return;
      }
      if (selectedWeek !== week || selectedYear2 !== year2) {
        setSelectedEndWeekAndYear([week, year2]);
      }
      const startDate = getStartOfISOWeek(selectedWeek, selectedYear2);
      const endDate = getEndOfISOWeek(week, year2);
      handleWeekClick({
        startYear: selectedYear2,
        startWeek: selectedWeek,
        startDate,
        endYear: year2,
        endWeek: week,
        endDate,
        // 현재 주까지 포함
        selectedWeeksRange: differenceInCalendarISOWeeks(endDate, startDate) + 1
      });
    }
  };
  return /* @__PURE__ */ jsxs(WeekContainer, { children: [
    /* @__PURE__ */ jsx(
      YearStepper_default,
      {
        date: currentDate,
        decreaseYear: () => {
          setCurrentDate(new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), currentDate.getDate()));
        },
        minDate,
        maxDate,
        prevYearButtonDisabled: minDate ? minDate.getFullYear() === currentDate.getFullYear() : false,
        nextYearButtonDisabled: maxDate ? maxDate.getFullYear() === currentDate.getFullYear() : false,
        increaseYear: () => {
          setCurrentDate(new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDate()));
        },
        changeYear: (year2) => {
          setCurrentDate(new Date(year2, currentDate.getMonth(), currentDate.getDate()));
        }
      }
    ),
    /* @__PURE__ */ jsx(WeekArea, { children: Years.map((each, index) => {
      const currentYear = currentDate.getFullYear();
      const currentWeek = Number(each);
      const isStart = currentYear === (selectedStartWeekAndYear == null ? void 0 : selectedStartWeekAndYear[1]) && currentWeek === (selectedStartWeekAndYear == null ? void 0 : selectedStartWeekAndYear[0]);
      const isEnd = (selectedEndWeekAndYear == null ? void 0 : selectedEndWeekAndYear[1]) === currentYear && (selectedEndWeekAndYear == null ? void 0 : selectedEndWeekAndYear[0]) === currentWeek;
      const isReady = isStart && Boolean(selectedEndWeekAndYear);
      let inRange = false;
      let disabled = false;
      if (minDate) {
        const minWeek = getISOWeek(minDate);
        const minYear = getISOWeekYear(minDate);
        if (currentYear < minYear) {
          disabled = true;
        }
        if (currentYear === minYear) {
          if (currentWeek <= minWeek) {
            disabled = true;
          }
        }
      }
      if (maxDate) {
        const maxWeek = getISOWeek(maxDate);
        const maxYear = getISOWeekYear(maxDate);
        if (currentYear > maxYear) {
          disabled = true;
        }
        if (currentYear === maxYear) {
          if (currentWeek >= maxWeek) {
            disabled = true;
          }
        }
      }
      if (selectedStartWeekAndYear && selectedEndWeekAndYear) {
        const [startWeek, startYear] = selectedStartWeekAndYear;
        const [endWeek, endYear] = selectedEndWeekAndYear;
        if (currentYear > startYear && currentYear < endYear) {
          inRange = true;
        }
        if (currentYear === startYear && currentYear === endYear) {
          if (currentWeek >= startWeek && currentWeek <= endWeek) {
            inRange = true;
          }
        }
        if (currentYear === startYear && currentYear !== endYear) {
          if (currentWeek >= startWeek) {
            inRange = true;
          }
        }
        if (currentYear === endYear && currentYear !== startYear) {
          if (currentWeek <= endWeek) {
            inRange = true;
          }
        }
      }
      return /* @__PURE__ */ jsx(
        EachWeekArea,
        {
          inRange,
          isStart,
          isReady,
          isEnd,
          disabled,
          onClick: () => {
            if (disabled) {
              return;
            }
            clickWeek(Number(each), currentDate.getFullYear());
          },
          children: /* @__PURE__ */ jsxs(EachWeekDate, { inRange, isStart, isEnd, disabled, children: [
            "W",
            each
          ] })
        },
        index
      );
    }) })
  ] });
};
var WeekDatepicker_default = WeekDatepicker;
var StyledNumberCombobox = styled6.div``;
var IconWrapper2 = styled6(motion.div)`
  display: flex;
  width: fit-content;
  height: fit-content;
`;
var NumberCombobox = (_a) => {
  var _b = _a, {
    disabled,
    onSelect,
    onChange,
    value,
    width = "90px",
    onBlur,
    items,
    isError,
    sizeVar = "M",
    placeholder = "Enter",
    maxLength,
    className
  } = _b, rest = __objRest(_b, [
    "disabled",
    "onSelect",
    "onChange",
    "value",
    "width",
    "onBlur",
    "items",
    "isError",
    "sizeVar",
    "placeholder",
    "maxLength",
    "className"
  ]);
  const selector = useRef(`shoplflow-${crypto.randomUUID()}-number-combobox`).current;
  const inputRef = useRef(null);
  const [isOpen, setIsOpen] = useOutsideClick({
    selector: `.${selector}`,
    useOutsideScroll: true
  });
  let _className = `${selector}`;
  if (className) {
    _className += ` ${className}`;
  }
  return /* @__PURE__ */ jsx(StyledNumberCombobox, { "data-shoplflow": "NumberCombobox", color: "shopl300", className: _className, children: /* @__PURE__ */ jsxs(Popper_default, { middlewares: [offset$1(4)], children: [
    /* @__PURE__ */ jsx(Popper_default.Trigger, { isOpen, className: _className, children: /* @__PURE__ */ jsx(
      Input_default,
      __spreadValues({
        sizeVar,
        width,
        ref: inputRef,
        type: "number",
        style: { textAlign: "left", paddingRight: "0px" },
        className: _className,
        gap: "4px",
        initIsFocused: isOpen,
        value,
        onChange,
        onFocus: () => {
          setIsOpen(true);
        },
        autoCapitalize: "off",
        customNumberInputHeight: sizeVar === "S" ? "32px" : "40px",
        isError,
        minWidth: `calc(100% -32px)`,
        autoComplete: "off",
        autoCorrect: "off",
        placeholder,
        disabled,
        onKeyDown: (event) => {
          var _a2;
          if (event.key === "ArrowUp" || event.key === "ArrowDown") {
            event.preventDefault();
            return;
          }
          setIsOpen(true);
          if (event.key === "Enter") {
            const currentValue = event.currentTarget.value;
            onSelect == null ? void 0 : onSelect(currentValue);
            setIsOpen(false);
            (_a2 = inputRef.current) == null ? void 0 : _a2.blur();
            return;
          }
        },
        maxLength,
        onBlur: (event) => {
          const target = event.target;
          const isNested = Boolean(target.closest(`.${_className}`));
          if (isNested) {
            return;
          }
          onBlur == null ? void 0 : onBlur(event);
        },
        rightSource: /* @__PURE__ */ jsx(StackContainer_default.Horizontal, { padding: "0px 4px 0px 0px", children: /* @__PURE__ */ jsx(
          IconButton_default,
          {
            sizeVar: "XS",
            styleVar: "GHOST",
            className: _className,
            onClick: () => {
              if (disabled) {
                return;
              }
              setIsOpen((prev) => !prev);
            },
            style: { cursor: disabled ? "not-allowed" : "cursor" },
            children: /* @__PURE__ */ jsx(
              IconWrapper2,
              {
                animate: {
                  rotate: isOpen ? 180 : 0,
                  transition: {
                    duration: 0.2
                  }
                },
                children: /* @__PURE__ */ jsx(
                  Icon_default,
                  {
                    iconSource: DownArrowSolidXsmallIcon,
                    sizeVar: "XS",
                    color: "neutral400",
                    style: { cursor: disabled ? "not-allowed" : "cursor" }
                  }
                )
              }
            )
          }
        ) })
      }, rest)
    ) }),
    /* @__PURE__ */ jsx(Popper_default.Portal, { children: /* @__PURE__ */ jsx(
      SimpleBarReact,
      {
        className: _className,
        style: {
          height: "128px",
          maxHeight: "128px",
          width,
          padding: "4px",
          filter: "drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.12))",
          boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.12)",
          borderRadius: "8px",
          backgroundColor: colorTokens.neutral0
        },
        children: items.map((item) => /* @__PURE__ */ jsx(
          Menu_default,
          {
            isSelected: value === item.value,
            onClick: () => {
              if (disabled) {
                return;
              }
              onSelect == null ? void 0 : onSelect(item.value);
              setIsOpen(false);
            },
            children: /* @__PURE__ */ jsx(Text_default, { typography: "body1_400", children: item.label })
          },
          item.value
        ))
      }
    ) })
  ] }) });
};
var NumberCombobox_default = NumberCombobox;

// src/components/Comboboxs/NumberCombobox/NumberCombobox.types.ts
var NumberComboboxSizeVariants = {
  S: "S",
  M: "M"
};
var SpaceMarginWrapper = styled6(motion.div)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  z-index: 101;
  //padding: 32px 20px;
  width: 100%;
  height: 100%;
`;
var ModalPortal = () => {
  const modal = useContext(ModalContext);
  return /* @__PURE__ */ jsx(Fragment, { children: createPortal(
    /* @__PURE__ */ jsx(AnimatePresence, { children: modal.map((item, index) => /* @__PURE__ */ jsx(BackDrop_default, { zIndex: item.zIndex, children: /* @__PURE__ */ jsx(SpaceMarginWrapper, { children: item.component }) }, index)) }),
    document.body
  ) });
};
var ModalPortal_default = ModalPortal;
var PopperPortal2 = () => {
  return /* @__PURE__ */ jsx(Fragment, { children: createPortal(
    /* @__PURE__ */ jsx(
      "div",
      {
        id: "popper-portal-key",
        style: {
          zIndex: 20001,
          position: "relative"
        }
      }
    ),
    document.body
  ) });
};
var PopperPortal_default = PopperPortal2;
var ShoplflowProvider = ({ children, domain = "SHOPL" }) => {
  useDomain(domain);
  return /* @__PURE__ */ jsxs(ModalProvider_default, { children: [
    /* @__PURE__ */ jsx(PopperPortal_default, {}),
    /* @__PURE__ */ jsx(ModalPortal_default, {}),
    /* @__PURE__ */ jsx(LazyMotion, { features: domAnimation, children })
  ] });
};
var ShoplflowProvider_default = ShoplflowProvider;
/*! Bundled license information:

classnames/index.js:
  (*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  *)
*/

export { AnnualDatepicker_default as AnnualDatepicker, Avatar_default as Avatar, AvatarSizeVariants, Button_default as Button, ButtonSizeVariants, ButtonStyleVariants, CHECKBOX_SYMBOL_KEY, Callout_default as Callout, CalloutTypes, Checkbox_default as Checkbox, CheckboxStyleVariants, ChipButton_default as ChipButton, ChipButtonSizeVariants, ChipButtonStyleVariants, ChipToggle_default as ChipToggle, ChipToggleSizeVariants, ChipToggleStyleVariants, DayDatepicker_default as DayDatepicker, DayDatepickerSizeVariants, Dropdown_default as Dropdown, Icon_default as Icon, IconButton_default as IconButton, IconButtonSizeVariants, IconButtonStyleVariants, IconSizeVariants, Input_default as Input, InputButton_default as InputButton, InputSizeVariants, List_default as List, MODAL_FOOTER_KEY, MODAL_HEADER_KEY, Menu_default as Menu, MenuSizeVariants, MinusButton_default as MinusButton, Modal, ModalContext, ModalHandlerContext, ModalPortal_default as ModalProvider, ModalSize, MonthDatepicker_default as MonthDatepicker, MotionStack, MotionStackContainer, NumberCombobox_default as NumberCombobox, NumberComboboxSizeVariants, Pagination_default as Pagination, Popper_default as Popper, PopperPortal, PopperTrigger, RADIO_SYMBOL_KEY, Radio_default as Radio, ScrollArea_default as ScrollArea, SelectInputButton_default as SelectInputButton, ShoplflowProvider_default as ShoplflowProvider, Stack_default as Stack, StackContainer_default as StackContainer, StyledIcon, StyledStack, StyledStackContainer, Switch_default as Switch, TREE_SYMBOL_KEY, TabSizeVariants, TabStyleVariants, Tabs_default as Tabs, TabsContext, Tag_default as Tag, TagSizeVariants, TagStyleVariants, Text_default as Text, Text2Rows, TextArea_default as TextArea, ToggleButton_default as ToggleButton, ToggleButtonSizeVariants, Tooltip_default as Tooltip, Tree_default as Tree, TreeItem, WeekDatepicker_default as WeekDatepicker, borderRadiusTokens, boxShadowTokens, colorTokens, fontWeightTokens, getDomain, spacingTokens, typographyTokens, useDomain, useHandleModal, useModalValue, useTabs };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.js.map